var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 824 980",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h824v980h-824z",
    fill: "#FBFAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 21 10 8 3 13 7 10 8v2l4 2 13 17 10 19 7 21 5 25 3 14v20h-2l-1 5-7 10-4 6-2 7-3 11-2 2-2 7-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 4 2 4-17 4-6 2-5 7-5 18-5 15-2 24-1 22 1 19 3 19 5 17 7 6 2v2h4l3 10 7 40 2 14 1 16v37l-4 16-4 9-9 12-7 5-4 2h-15l-22-1 1 1-1 8-2 39-3 20-4 16-3 9-3 16v8l7 9v15l-2 5-8 9-15 8-22 7-28 7v15l3 2v38l15 4 21 6 9 3 12 3 3 2 1 12 4 4 2 3v8l-6 7-2 1h-12l-5-3-3-5v-9l4-7h-17l-29-1-2 5-10 13-8 12v5l1 1v11l-3 8-5 2-1 81-15 7-10 2-10-5-7-5-2-14-3-43-1-18-2-15-1-14-19 6 2 8v13l-1 15-4 4-8 1-10 11-14 8-12 5-7 1h-14l-8-4-3-3 2-5 10-8 8-7h2l1-3h2l1-3h2l2-4 8-11v-2l-21 5-31 11-8 3-20 6-31 11-13 4-11 4-9 2-6 2-2 65-2 60-8 4-14 3-2-1-1 2-12-7-18-9-2-24-5-82-1-16-1-2-7-4-28-17-11-6-17-10-11-6-26-14-13-8-20-12-35-20-16-9-20-12-11-6-14-8-16-10-2-1v-2h-2l-1 95v29h-5l-8-6-11-6-1-1-4-76-1-11-3-62-2-50-1-3v-15l-4-2-13-7-1-30 11-4 36-8 23-3h4l-1-3-7-3-15-8-5-3-6-41-6-38-4-30-3-17-3-21-3-18-4-31-4-24-2-13-2-20 8-3 4-1h20l27 5 33 7 12 3 14 3 30 7 4 2 2 17 2 11 1 13v14l-10 3-1 2 28 5 102 19 7 2 17 3 36 6 26 4h7l16-8h6l3 9v3l9 3 7 2h17l9-2 16-8 14-8 3-2h3v-2l12-7 11-9 8-7 6-5 8-14 3-5 1 2-5 13-3 11-5 12 3 2 7 1v2l-14-1-3 9v11l2 6h3l2-11h2l2-4 3-2 7 1 16 7 9 5 1 2-6-1-17-8-9-3-5 6-2 9 4 10 11 8 12 4 16 8 9 4 22 6h2l13 39h21l11-3 15-3 11-5h2l-3-16-3-11-4-22v-10l4 4 7 20 5-1 4-5 2-5v-7l-5-12-5-9-8-12-9-11v-2l-4-2-6-7-8-7-4-2-3-3-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-3-1h-7l-11 7-7 8-1 2h-2l-2 6-4 7h-1l-2-12-4-10-5-12-9-13-8-11-8-13-6-12-5-13-2-10h-2l-2 5-19 19-18 13-21 12-12 5-16 3h-17l2-4 10-11 10-15 9-19v-1l-8 7-8 6-14 9-22 12-7 4-5 2-8 5-7 4-4 5-3 2-3 6-3-3-4-8-2-5-4-26v-25l4-19 4-11 7-14h2l1-4 4-5 1-3h2l2-5 12-13 12-11 15-11 17-10 12-6 13-5 20-6 13-2h17z",
    fill: "#DAB682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,378)",
    d: "m0 0 5 1 2-1v602h-824v-288l6-1 3 3-5-1 1 3 3 1v-2l5-1 7 3-2-3-4-2v-3l11-5 3-4-1-6 3-3h1l2 16 1 25 2 29 3 58 14 8 5 4 5 1-1-6v-35l1-77 1-6h2v2l5 2 10 6 21 12 20 12 11 6 14 8 19 11 21 12 30 18 24 13 28 16 27 16 13 8 5 3 1 2 4 65 3 44v13l5 2 16 8 9 5 5-1 14-4 5-2 2-60 2-65 9-4 10-2 16-6 17-5 15-6 15-4 15-5 30-11 18-5 7-1-1 5-10 13-5 4-5 5-7 6-8 6-2 5 5 4 5 2h14l9-2 16-7 10-7 8-9 10-2 1-2 1-15v-13l-2-8 7-3 10-3 3-1 1 1 2 25 1 4 2 35 3 35v5l4 2 8 5 5 2 10-2 14-6 1-71 1-10 5-3 2-7v-11l-1-1 1-7 13-18 7-10h29l17 1-2 5-1 2v9l3 5 4 2h12l6-5 1-2v-8l-3-5-3-2-1-12-8-3-12-3-14-4-10-3-15-4-1-1v-38l-3-2v-15l3-2 19-4 29-9 15-8 8-9 1-4v-15l-7-9v-8l3-16 3-9 4-16 3-20 2-39 1-8-2-2h10l14 1h15l11-7 10-14 3-9 3-13z",
    fill: "#FBFAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 21 10 8 3 13 7 10 8v2l4 2 13 17 10 19 7 21 5 25 3 14v20h-2l-1 5-7 10-4 6-2 7-3 11-2 2-2 7-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 4 2 4-17 4-6 2-5 7-5 18-5 15-2 24-1 22 1 19 3 19 5 17 7 6 2v2h4l3 10 7 40 2 14 1 16v37l-4 16-4 9-9 12-7 5-4 2h-15l-22-1 1 1-1 8-2 39-3 20-4 16-3 9-3 16v8l7 9v15l-2 5-8 9-15 8-22 7-28 7v15l3 2v38l15 4 21 6 9 3 12 3 3 2 1 12 4 4 2 3v8l-6 7-2 1h-12l-5-3-3-5v-9l4-7h-17l-29-1-2 5-10 13-8 12v5l1 1v11l-3 8-5 1v-81l6-2 1-43h4l-1-13-11-1-1-5 9-2 9-4 8-3h3v-12l1-15h-2v-2l-7-1-19-8-14-6-6-3v12l-1 9-8 4-5 2-6 1h-13l-15-3-8-4-2-3-11-4-3-3v-12l3-8 2-8 2-4h10v-3l-6-1-16-8-1-3 15-3 5-4h2l-3-7-1-1v-8l-28 6-7 3-13 2h-23l-10 4-5 4-3 1 11 5 10 3 17 8 10 4 3 2v5l-10 5-14 6h-7l-4-2-10-2-7-3v-2l-10-1-11-2h-5l2 16h19l3 2-2 4-5 3h-3l-1 3-2 1h-10l-9 3v2l-11 7-1 2-7-1 4-1v-9l-5-26-4-21-11-58-7-43-7-38-4-26-1-18 17-8 1-1h6l3 9v3l9 3 7 2h17l9-2 16-8 14-8 3-2h3v-2l12-7 11-9 8-7 6-5 8-14 3-5 1 2-5 13-3 11-5 12 3 2 7 1v2l-14-1-3 9v11l2 6h3l2-11h2l2-4 3-2 7 1 16 7 9 5 1 2-6-1-17-8-9-3-5 6-2 9 4 10 11 8 12 4 16 8 9 4 22 6h2l13 39h21l11-3 15-3 11-5h2l-3-16-3-11-4-22v-10l4 4 7 20 5-1 4-5 2-5v-7l-5-12-5-9-8-12-9-11v-2l-4-2-6-7-8-7-4-2-3-3-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-3-1h-7l-11 7-7 8-1 2h-2l-2 6-4 7h-1l-2-12-4-10-5-12-9-13-8-11-8-13-6-12-5-13-2-10h-2l-2 5-19 19-18 13-21 12-12 5-16 3h-17l2-4 10-11 10-15 9-19v-1l-8 7-8 6-14 9-22 12-7 4-5 2-8 5-7 4-4 5-3 2-3 6-3-3-4-8-2-5-4-26v-25l4-19 4-11 7-14h2l1-4 4-5 1-3h2l2-5 12-13 12-11 15-11 17-10 12-6 13-5 20-6 13-2h17z",
    fill: "#6B7480"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,254)",
    d: "m0 0h20l27 5 33 7 12 3 14 3 30 7 4 2 2 17 2 11 1 13v14l-10 3-1 2 28 5 102 19 7 2 17 3 36 6 31 5 4 31 5 30 8 44 3 20 13 68 3 17 4 20v10l-8-1-7-3-33-10-7-3-14-3-13-4-15-5-20-6-2-1 1-14 6-35 2-11h-2l-3 21-2 10-1 11-2 10-3 26-2 13-1 11v12l2 16 4 12 3 3 9 7h24l18-5 23-7 6-1v-2l-16-8-11-5-3-1v-7l-4-2-3-2 1-3 10-3 4-2h7l-1-3 4 1 19 9 13 7 5 2 15 7v2l6 2 10 5 6 2h13v-2l8-2 3-2 12-2v-2l6-2h5v-2l8-1v-2l37-13 6-2h4v12l-9 4-30 11-24 9-23 8-13 4-2-1 1-11-10-3-4-1-1 2 5 2 4 1 2 1v2l2 1-9 3 7 2-4 1-9-2-16-8-8-5v-2h-3l2 5-12 4-20 4-26 8-17 5-14 4-2 2-8-1-7-3-9-2-9-4h-3l-1-4-4-1-14-7-5-3-3-4 5 1 4 3 22 10 17 4v-2l-15-5-13-5-11-5-3-5-3-10-1-7v-30l4-35 1-6-15-6-5-3v-10h3l1 2 3 1h9l1-4-1-10-3-2-11-2-4-1-4 4-1 5h-3l-2-12-2-3-7 1-5 7-2 3-10-30-7-22-1-3 2 18 2 9 3 27 2 14v10l-7 5-12 6-1 1h-6l-19-10-9-5-8-5-6-2-1-2h-6l-1-3 4-4 5-3v-5l-5 1-3 3h-2l-1 4-11 12-9 13-9 14-5-1-14-7 1-9 1-10v-33l-7-3-15-8-5-3-6-41-6-38-4-30-3-17-3-21-3-18-4-31-4-24-2-13-2-20 8-3z",
    fill: "#434D52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 21 10 8 3 13 7 10 8v2l4 2 13 17 10 19 7 21 5 25 3 14v20h-2l-1 5-7 10-4 6-2 7-3 11-2 2-2 7-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 4 2 4-17 4-6 2-5 7-5 18-5 15-2 24-1 22 1 19 3 19 5 17 7 6 2v2h4l3 10 7 40 2 14 1 16v37l-4 16-4 9-9 12-7 5-4 2h-15l-14-1-21-3-3-1-11-1-6-2 3 9 7 14 1 5-3-1-11-22v-3h-2l-6-15-9-25-7-21-6-9-4-10-5-9-8-12-9-11v-2l-4-2-6-7-8-7-4-2-3-3-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-3-1h-7l-11 7-7 8-1 2h-2l-2 6-4 7h-1l-2-12-4-10-5-12-9-13-8-11-8-13-6-12-5-13-2-10h-2l-2 5-19 19-18 13-21 12-12 5-16 3h-17l2-4 10-11 10-15 9-19v-1l-8 7-8 6-14 9-22 12-7 4-5 2-8 5-7 4-4 5-3 2-3 6-3-3-4-8-2-5-4-26v-25l4-19 4-11 7-14h2l1-4 4-5 1-3h2l2-5 12-13 12-11 15-11 17-10 12-6 13-5 20-6 13-2h17z",
    fill: "#303B46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,171)",
    d: "m0 0h2l6 19 8 16 6 9 3 5 7 10 9 13 5 12 4 10 2 10 5-9 1-2h2l2-5 7-7 10-6h7l6 3 4 5 1 5v16l-4 11-5 8-10 10-11 6-12 4 10-2 8-4 5 1 11 7 1 1 15 3 22 10v2l6 2 6 4v2l5 2 8 7 7 8 5 5 10 13 8 13 5 10 2 6v7l-4 8-4 4-5-1-8-22-1-1v9l5 27 4 15v7l-13 6-23 5-3 1h-21l-3-7-10-31-7-2-23-7-24-12-8-3-11-8-4-11 3-9 5-6 9 3 19 9h3l-17-9-11-4-6 1-3 4h-2l-1 12-4-1-3-6v-11l3-7 1-2h10l4 1v-2h-7l-4-2 4-12 3-8 6-18-10 18-13 12-12 9-9 6-4 1v2l-8 4-9 5-12 7-11 4-5 1h-17l-11-3-5-3-3-11-4-2h3l-2-4-4 3-4-2-3-3v-2l-4-2-9-10-12-16-6-11-6-20-3-21-9-31-2-11-1-7h-3l6-7 5-4 10-5 2-2 7-3 23-12 11-7 12-8 8-8 4-2-2 6-10 19-10 14-10 11-1 2 17-1 16-3 16-7 17-10 19-14 17-17z",
    fill: "#F1C399"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,544)",
    d: "m0 0 4 1 24 12 22 12 23 12 15 8 1 10 5 4v2l7 2 17 1 6 2 34 18 16 9 22 12 23 13 11 6 28 15 46 25 20 11 4 2-1 28 15-1v14l3 2h-3v207l-5-1-16-8-9-5-2-24-5-82-1-16-1-2-7-4-28-17-11-6-17-10-11-6-26-14-13-8-20-12-35-20-16-9-20-12-11-6-14-8-16-10-2-1v-2h-2l-1 95v29h-5l-8-6-11-6-1-1-4-76-1-11-3-62-2-50-1-3v-15l-4-2-13-7z",
    fill: "#715F4F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,484)",
    d: "m0 0 2 3 5 16 11 33 1 4 7-9 7-1 3 4 1 12h3v-5l5-5 7 2 10 2 2 2 1 13-2 2h-9l-4-2v-2h-3l1 10 14 6 6 3-4 31-1 10v30l2 10 3 8 2 4 13 5 15 6 12 4-1 3-10-2-13-4-19-9-4-2v2l5 2 15 8 3 1v2l2 1 3 1 11 4 12 3 1 1 8 1 2-2 7-2 34-10 20-6 19-4 8-3-1-4h3l4 4 19 9 5 2h2l-3-2 7-1 3-2v-2l-7-1v-2l-4-1 1-3 9 2 5 3v11l12-3 21-8 23-8 43-16 1-12-36 12-8 3h-3v2l-8 1v2l-11 2v2l-12 3-5 3h-6v2l-13 1-12-5-10-5v-2l-9-3-6-3-15-7-19-10-6-2v2l-9 2-7 3-5 1v2l6 4v7l6 1 21 10 4 3-1 3-16 4-15 5-16 4h-24l-9-7-4-4-4-12-2-16v-12l2-20 3-20 2-18 1-2 2-18 2-12 3-12h2v7l-4 20-3 19-1 11-1 3 11 3 21 6 8 3 17 5 9 2 27 9 17 5 7 3 4 1 2-4 8-5h2v-2l8-3 1-8h1v8l9-1 3-3 9-5v-2l-2-1-19-1-1-2-1-14 8-1 18 4v2l5 1 4 2 8 1 4 2h7l10-4 12-6h2l-1-5-8-4-13-5-10-5-9-3-11-4 1-2 7-4 8-4 3-1h23l13-2 10-4 21-4h4l1 8 3 4v4l-7 5-9 2h-6l4 4 16 7 3 1v3l-10 1-2 5-2 9-2 5v12l5 3 9 4 4 4 13 4 7 1h13l8-2 10-4 2-21 9 3 13 6 20 8 3 2v2l-17 5-36 12-44 14-24 7-36 12-105 36-52 17-12 4-5 1-16-8-50-27-24-13-14-8-22-12-23-13-11-6-34-18-10-6-5-1-17-1-7-3v-2l-4-2-2-2v-10l-6-2-23-12-22-12-33-17-4-2v8h-1v-9l11-4 36-8 23-3h4v30l-2 13-1 6 6 2 9 5h4l12-19 8-10 9-10 1-3 6-5 5 1v5l-7 5h-2l1 4h5l4 3 14 7 17 10 8 4h6l10-6 7-4 3-1-5-39-1-12-3-15z",
    fill: "#DAB683"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,51)",
    d: "m0 0h36l13 2 15 5 4 2v2l-4 2h-14l-12-7-6-1v2l7 2 6 5v2l-23 3-22 5-2 1h17l8 1 5 2-1 5-5 9 4-2 3-6 2-3h3v-3h6l3 4 3-1 2-12 2-1h10l9 3 12 7 10 8 7 6-13-13-11-7-5-3v-2h8l13 3 13 7 9 7v2l4 2 12 14 11 19 8 21 6 25 3 18v15l-6 5-6 4-13 6-13 4-21 3h-8l-12-3-8-8v-2h17l-5-2-7-4v-2l-4-2-9-9-8-14-5-19-4-18-3-23-3-14 1 13v14l-4 19-6 12-8 10-10 10-13 9-13 8-20 9-8 2 2-6 7-10 5-11 3-10 1-17h-2l-1 5-8 7-19 11-24 10-18 6-20 5h-4l-4-15v-22l4-15 5-12 6-10h2l2-5 11-12 12-9 10-6 17-8 9-4-19 7-16 8-11 7-12 11-2 1 1-4 8-10 7-7 10-8 18-12 16-9 20-8 20-5z",
    fill: "#FEF084"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(18,258)",
    d: "m0 0 4 1 17 4 19 4 6 2 14 3 16 4 19 5 31 7 2 26-1 5-2-1-4-16-1-3-3-1-1 1 1 20 1 8 1 2 1 18 2 13 2 20 1 8 1 1 2 21 3 25 1 13 2 10 2 20 1 11-1 2h2l1 15 1 4 1 5 6 2 4 8 2 8-3 10 1 11 7 11 6 2-1 4 3 1v2l6-1-4 4h-6l-19-10-9-5-8-5-6-2-1-2h-6l-1-3 4-4 5-3v-5l-5 1-3 3h-2l-1 4-11 12-9 13-9 14-5-1-14-7 1-9 1-10v-33l-7-3-15-8-5-3-6-41-6-38-4-30-3-17-3-21-3-18-4-31-4-24-2-13z",
    fill: "#1A1F22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,363)",
    d: "m0 0h3l-1 8 2 9 9 17 6 11 8 19 4 6 2 2v-5l2 2 3 16 2 5 1 5v7l-2 1 3 1 7 28 5 9 1 3 10-4 8-2 4 1 7 11 8 10v3l-15 3-15 2-21 4-19 6-16 1h-20l-14 9-4 1 1-4 4-5h2v-2l7-5h2v-3l-13 1-12 7-4-1 1-5 5-8 7-5 10-3 6-2h-14l-9 4-5 5-4 7-4 1-2-4 1-9 6-9 5-5 9-4h12l7 3-10-8-4-5-9-7-2-1-9 1-12 8-3 3h-2v2l7-3 8-6 4-2h5l10 6 3 3v3l-13 5-8 6-2 4h-3l-1 3h-2v-2h-11l-1-7v-11h-2l-6-34v-10l-2-6-4-23-2-8-2-19-1-1v-8l6 1 9 3h17l9-3 16-7 10-6 12-8z",
    fill: "#F0C398"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,516)",
    d: "m0 0 1 3-3 5-14 9-8 4-18 6-18 4-23 2v4l6 2 15 3 1 1h13l9-3 17-6 13-7 9-7 3 1 3 10 2 19v10l-2 10v8l7 9v15l-2 5-8 9-15 8-22 7-28 7v15l3 2v38l15 4 21 6 9 3 12 3 3 2 1 12 4 4 2 3v8l-6 7-2 1h-12l-5-3-3-5v-9l4-7h-17l-29-1-2 5-10 13-8 12v5l1 1v11l-3 8-5 1v-81l6-2 1-43h4l-1-13-11-1-1-5 9-2 9-4 8-3h3v-12l1-15h-2v-2l-7-1-19-8-14-6-6-3v12l-1 9-8 4-5 2-6 1h-13l-15-3-8-4-2-3-11-4-3-3v-12l3-8 2-8 2-4h10v-3h3l1 2 4 1h28l13-1-7-2-2-3-4-1 1 5h-21l-1-4-4 2h-6l-1-4 1-3 11-2h21l8 2 4 2 1 5h4l2-9-1-2h2l1-3 3 1 1-5-3-1v-2l-2-1 44-1 25-6 15-6 14-8 4-2 2-4z",
    fill: "#584433"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,484)",
    d: "m0 0 2 3 5 16 11 33 1 4 7-9 7-1 3 4 1 12h3v-5l5-5 7 2 10 2 2 2 1 13-2 2h-9l-4-2v-2h-3l1 10 14 6 6 3-4 31-1 10v30l2 10 3 8 2 4 13 5 15 6 12 4-1 3-10-2-13-4-19-9-4-2v2l5 2 15 8 3 1v2l2 1 3 1 21 8v2l5 1v1l-9-1-16-6-26-13v-2l-5-1-3-1v-2l-4-1-6-4 4 5h-3l1 2-6-2-16-9-24-13-12-7-11-6-34-18-10-6-5-1-17-1-7-3v-2l-4-2-2-2v-10l-6-2-23-12-22-12-33-17-4-2v8h-1v-9l11-4 36-8 23-3h4v30l-2 13-1 6 6 2 9 5h4l12-19 8-10 9-10 1-3 6-5 5 1v5l-7 5h-2l1 4h5l4 3 14 7 17 10 8 4h6l10-6 7-4 3-1-5-39-1-12-3-15z",
    fill: "#DAB683"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,308)",
    d: "m0 0 5 1 11 7 1 1 15 3 22 10v2l6 2 6 4v2l5 2 8 7 7 8 5 5 10 13 8 13 5 10 2 6v7l-4 8-4 4-5-1-8-22-1-1v9l5 27 4 15v7l-13 6-23 5-3 1h-21l-3-7-10-31-7-2-23-7-24-12-8-3-11-8-4-11 3-9 5-6 9 3 19 9h3l-17-9-11-4-6 1-3 4h-2l-1 12-4-1-3-6v-11l3-7 1-2h10l6 1 7-7 9-14 8-20 1-1 1-8z",
    fill: "#ECFCFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,398)",
    d: "m0 0 4 4 7 20 5-1 4-5 2-5 1-6 4 5 4 9 11 33 7 18v2h2l9 20 2 2v3h2l-1-4-9-18v-5l17 2 12 2 7 1-3 2 1 1-1 8-2 39-3 20-4 16-3 9-2-4-2-19-3-10-4 2-14 9-8 4-24 8h-13l-9-3-7-1-6-3v-4l2-1 21-2 21-5 15-5 15-8 8-6 1-5-8 7-10 6-14 7-17 5-14 3-42 1v2l4 1-2 5h-3l-1 2-1 1 1 2-3 9-5-1v-5l-12-3h-21l-11 1v7l10-2 1 3 21 1-1-5 5 1 1 3 8 1-1 2-13 1h-28l-5-2v-2h-3l-1-7 5-5 5-2 8-1h20l-1-4-2-2 3-1-8-3-2-1 1-5 3-7v-6l-3-12-5-10-3-3v-4l3-1v-4l-8 6h-3v5l-2-4 2-7 5-5 8-3h7l8 4 3 2 12-3 4-2v-12l21-6 15-3 11-5h2l-3-16-3-11-4-22z",
    fill: "#6079AF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,254)",
    d: "m0 0h20l27 5 33 7 12 3 14 3 30 7 4 2 2 17 2 11 1 13v14l-10 3-1 2 28 5 64 12 21 4-3 2v5l-11-1h-14l-13-2-11-2-19-1-14 3-11 6-2 9 1 14 2 14 3 24-2-1-2-12v4l7 34 1 7-1 3 4 4 5 18 3 21 1 3 3 27 2 14v10l-7 5-9 4h-6l-3-3-1-4-5-2-7-11-1-11 3-11-3-10-3-5h-4l-2-2-1-7-1-2v-15h-2v-6l-1-7-2-20-2-10-1-13-2-18-3-28-1-2-1-13-1-4v-6l-1-5-2-14-1-16-2-10-1-20 1-2 3 1 4 7 3 13 1-4-1-13v-13l-8-1-36-8-18-5-11-3-11-2-6-2-25-5-8-3-2-2z",
    fill: "#44413F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,610)",
    d: "m0 0h2v2h2v15l-1 12-11 4-9 4-9 2-2 8-8 4-27 7-18 6-8 2-17 6-24 8-63 20-17 5-10 6-10 4-7 3-16 5-9 3-9 2-8 2-12 2-23 5-5 2h-11v-24l1-4 11-4 44-15 37-12 43-15 41-14 27-9 49-15 50-16 23-8h5z",
    fill: "#BE8A4C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(274,515)",
    d: "m0 0 13 2 25 6 1 4-3 19-2 10-1 11-2 10-3 26-2 13-1 11v12l2 16 4 12 3 3 9 7h24l18-5 23-7 6-1v-2l-16-8-11-5-3-1v-7l-4-2-3-2 1-3 10-3 4-2h7l-1-3 4 1 19 9 13 7 5 2 15 7v2l6 2 10 5 6 2h13v-2l8-2 3-2 12-2v-2l6-2h5v-2l8-1v-2l37-13 6-2h4v12l-9 4-30 11-24 9-23 8-13 4-2-1 1-11-10-3-4-1-1 2 5 2 4 1 2 1v2l2 1-9 3 7 2-4 1-9-2-16-8-8-5v-2h-3l2 5-12 4-20 4-26 8-17 5-14 4-2 2-8-1-7-3-9-2-9-4h-3l-1-4-4-1-14-7-5-3-3-4 5 1 4 3 22 10 17 4v-2l-15-5-13-5-11-5-3-5-3-10-1-7v-30l4-35 7-37 4-24z",
    fill: "#666C73"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,544)",
    d: "m0 0 4 1 24 12 22 12 23 12 15 8 1 10 5 4v2l7 2 17 1 6 2 34 18 16 9 22 12 23 13 11 6 28 15 46 25 20 11 4 2-2 28-16-8-34-18-10-6-16-8-28-15-21-11-10-6-11-6-28-15-16-9-23-13-38-19-19-11-13-8-12-7-11-5-6-3-14-8z",
    fill: "#594433"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,592)",
    d: "m0 0 9 3 13 6 20 8 3 2v2l-17 5-36 12-44 14-24 7-36 12-105 36-52 17-12 4-5 1-16-8-50-27-24-13-2-2-3-4h3l-2-4 7 4 4 2v2l5 1 3 1v2l6 2 14 7 13 6 13 4h2l-2-1v-2l-7-2 3-1 7 3 8 1 2-2 7-2 34-10 20-6 19-4 8-3-1-4h3l4 4 19 9 5 2h2l-3-2 7-1 3-2v-2l-7-1v-2l-4-1 1-3 9 2 5 3v11l12-3 21-8 23-8 43-16 1-12-36 12-8 3h-3v2l-8 1v2l-11 2v2l-12 3-5 3-4-1-7 1v-6l3-3 30-11 36-12 23-9 2-2 9 2 20 4h4l1-3 13-1 12-3 10-4z",
    fill: "#DBB783"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,80)",
    d: "m0 0 3 1-17 7-16 8-14 10-11 10-6 9h-2l-2 5-7 14-4 13-1 5v22l3 12v3l28-7 19-7 23-10 18-11 5-6 1-3h2v17l-4 13-7 13-6 9v1l14-5 16-8 12-7 13-10 10-10 7-10 4-9 4-19v-14l-1-14 2 1 4 20 3 21 6 26 4 11 7 11 9 9 2 1v2l6 2 2 2 5 2v1h-11l-7-1 7 8 3 3-6 2 2 4 8 1h15l18-2 15-4 5-3h5l1 2-3 3-12 5-13 3-12 2h-22l2 4 5 2 3 1 2 4-2 1 7 2 9 1 2 2-10 9-2 4h-2l-2 6-4 7h-1l-2-12-4-10-5-12-9-13-8-11-8-13-6-12-5-13-2-10h-2l-2 5-19 19-18 13-21 12-12 5-16 3h-17l2-4 10-11 10-15 9-19v-1l-8 7-8 6-14 9-22 12-7 4-5 2-8 5-7 4-4 5-3 2-3 6-3-3-4-8-2-5 1-4v3h2l-2-16-1-9v-17l2-15 7-24h2v-4l4-3 4-9 7-11 3-2h2l8-8 10-7 14-8 20-8z",
    fill: "#8E5F3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,359)",
    d: "m0 0 14 1 4 2h-4l-3 9v11l2 6h3l2-11h2l2-4 3-2 7 1 16 7 9 5 1 2-6-1-17-8-9-3-5 6-2 9 4 10 11 8 12 4 16 8 9 4 22 6h2l13 39 18 1v1l-6 1-1 12-4 3-13 3-5-4-5-2h-7l-8 3-5 5-1 8 1-3 7-4 4-2 1 4-4 1 2 5 4 5 4 10 2 9v7l-4 8-1 3h2v2l-6 6h-5l-7-5-2-3-5-2-5-6v-2l21-3v-3h5l-4-7-7-9-5-8-9 1-3 2-9 2-6-10-2-4-5-24v-2l-4-1 3-1-3-16-2-5-2-11-1 4-4-5-5-10-7-17-7-11-8-16-1-9 1-7z",
    fill: "#607AB0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,363)",
    d: "m0 0h3l-1 8 2 9 9 17 6 11 8 19 3 5v2l-7 3-27 12-21 7-5 2-10 2h-22l-4-1v-2l-5-1-7-5-3-16-4-18-2-19-1-1v-8l6 1 9 3h17l9-3 16-7 10-6 12-8z",
    fill: "#FAF9F7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,308)",
    d: "m0 0 5 1 11 7 1 1 15 3 22 10v2l6 2 6 4v2l5 2 8 7 4 4-1 2-3-2v-2h-3v-2h-3v-2l-9-3-11-3h-18l-9 4-4 6-5 16-2 12v17l2 10 6 11 2 3v3l4 1 1 5-2 1-22-6-12-5-15-8-10-3-12-9-4-11 3-9 5-6 9 3 19 9h3l-17-9-11-4-6 1-3 4h-2l-1 12-4-1-3-6v-11l3-7 1-2h10l6 1 7-7 9-14 8-20 1-1 1-8z",
    fill: "#859FE1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,525)",
    d: "m0 0h2v7l-4 20-3 19-1 11-1 3 11 3 21 6 8 3 17 5 9 2 13 4 1 2-4 1 1 4-5-2-6-1-3-3 1 15 2-8 9 3v3l5 1 3 1 2 2h2l5 5-4 1-5-3-3-1h-10l-3-1v2l-9 2-7 3-5 1v2l6 4v7l6 1 21 10 4 3-1 3-16 4-15 5-16 4h-24l-9-7-4-4-4-12-2-16v-12l2-20 3-20 2-18 1-2 2-18 2-12z",
    fill: "#DAB683"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,432)",
    d: "m0 0 4 1 18 6 16 6v13l-1 1-1 20-1 38-1 12 5 1 5 5 5 1-5 4-4 2-1 4-11 12-9 13-9 14-5-1-14-7 1-9 1-10v-34h2l1-27 1-21 1-8v-33z",
    fill: "#31363A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,398)",
    d: "m0 0 4 4 7 20 5-1 4-5 2-5 1-6 4 5 4 9 11 33 7 18v2h2l9 20 3 5 3 7-1 5h-2l-2 5-5 6-9 7-22 11-6 1h-16l-37-7-2-4 18-7 8-3 10-2v-2l12-3 3-1v-10l-2-19-2-10-2-21-5-20-4-22z",
    fill: "#859FE1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(144,291)",
    d: "m0 0h1l6 38 2 17 2 10 1 14 3 12 2 15 3 21 2 13 1 5v12l2 7-1 5 2 1 1 7 2 8 1 7 1 3v13l2 6 3 12h2l6 8 1 3h2l3-10 2-5 3-1 1 4v11l3 7 3 21v10l-7 5-9 4h-6l-3-3-1-4-5-2-7-11-1-11 3-11-3-10-3-5h-4l-2-2-1-7-1-2v-15h-2v-6l-1-7-2-20-2-10-1-13-2-18-3-28-1-2-1-13-1-4v-6l-1-5-2-14-1-16-2-10-1-20 1-2 3 1 4 7 3 13 1-4-1-13z",
    fill: "#30363A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,430)",
    d: "m0 0 2 2 3 16 2 5 1 5v7l-2 1 3 1 7 28 5 9 1 3 10-4 8-2 4 1-6 3-13 4-17 4-2 1h-11l-14-6-21-13-12-11-8-6-7-2h-15l-9 4h-2v2l-5 3-5 8h3l-1 3-3 2-6-34v-10l-1-2 6 2 2 2 4 1v2h26l14-3 8-3 21-8 22-10 7-2h1z",
    fill: "#AA835E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,578)",
    d: "m0 0 11 2 10 2v2l5 1 4 2 8 1 4 2v2l7 1 33 15 10 6 2 3-15 6-19 7-46 16-13 4h-10l-1-8-10-2-24-12-16-9-10-5v-2l-2-2 7-1 29 9 7 3 4 1 2-4 8-5h2v-2l8-3 1-8h1v8l9-1 3-3 9-5v-2l-2-1-19-1-1-2-1-14z",
    fill: "#EFA435"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,297)",
    d: "m0 0 30 1 19 3 19 5 17 7 6 2v2h4l3 10 7 40 2 14 1 16v37l-4 16-4 9-9 12-7 4-2-2 1-14 2-19v-45l-3-42-3-23v-4l-6-1-11-4-18-6-10-2-2-1-28-2h-20l-28 2-10 3h-3l1-5 7-5 18-5 15-2z",
    fill: "#4C637C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 21 10 8 3 13 7 10 8v2l4 2 13 17 10 19 7 21 5 25 3 14v20h-2l-1 5-7 10-4 6-2 7-3 11-2 2-2 7-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 2 2-1 3-5-4-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-3-1h-7l-5 3-19-2-2-2 2-2-1-3h-5l-5-5v-2l22-1 22-4 13-5 4-1v-3l-7 1-7 3-16 4-13 1h-17l-7-2-1-4 3-2 21 1 21-3 13-4 16-8 8-6v-15l-5-27-5-19-8-20-10-17-13-15-2-1v-2l-4-2-8-6-10-5-13-3-8-1 3 3 10 6 10 9 7 7h-3l-8-8-10-7-11-6-7-2h-12v7l-2 6h-4l-2-3-6-1v3h-3l-5 10-4 1 2-5 4-9-5-1-10-1h-17l4-3 22-5 13-2h10l-5-5-8-4v-2h6l12 7h14l4-1v-2l-9-3-14-4-9-1h-36l-20 4-18 6-16 8-14 8-14 10-13 11-8 9-10 13-5 8-3 7-4 2v4h-2l-1 6-6 23-1 10v17l3 23-1 2h-2l-4-18-1-7v-25l4-19 4-11 7-14h2l1-4 4-5 1-3h2l2-5 12-13 12-11 15-11 17-10 12-6 13-5 20-6 13-2h17z",
    fill: "#31231D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,626)",
    d: "m0 0 4 1 19 9 13 7 5 2 15 7v2l6 2 10 5 6 2h13v-2l8-2 3-2 12-2v-2l6-2h5v-2l8-1v-2l37-13 6-2h4v12l-9 4-30 11-24 9-23 8-13 4-2-1 1-11-10-3-4-1-1 2 5 2 4 1 2 1v2l2 1-9 3 7 2-4 1-9-2-16-8-8-5v-2h-3l2 5-12 4-20 4-26 8-17 5-14 4-2 2-8-1-7-3-9-2-9-4h-3l-1-4-4-1-14-7-5-3-3-4 5 1 4 3 22 10 17 4 2-2h8l-7-8 1-2 9 7h24l18-5 23-7 6-1v-2l-16-8-11-5-3-1v-7l-4-2-3-2 1-3 10-3 4-2h7z",
    fill: "#C7A881"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,668)",
    d: "m0 0 19 1 3 2v38l15 4 21 6 9 3 12 3 3 2 1 12 4 4 2 3v8l-6 7-2 1h-12l-5-3-3-5v-9l4-7h-17l-29-1-2 5-10 13-8 12v5l1 1v11l-3 8-5 1v-81l6-2 1-40z",
    fill: "#1D2225"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,649)",
    d: "m0 0 3 4-1 14-2 2-14 4-37 13-36 12-36 13-21 7-43 15-40 13-17 6-23 7-18 5-4-2v-11l2-5 26-6 15-2 4-2 9-2 17-5 12-4 5-3 10-4 9-5 30-9 50-16 33-11 7-3 12-3 19-6 23-6 5-2z",
    fill: "#A0897A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,520)",
    d: "m0 0 19 1 1 7-2 5 2 1-1 4 1 2-7 3h-4l1 9v21l5 2 9 5 3 2 1 15 1 3 3 70v8h-1l-1-6h-2l1 8-4 5-9 4h-2l1 3 5 3v2l-4-1-8-1v2l-4-1v-3h4l-5-1h-3z",
    fill: "#FAF9F7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,102)",
    d: "m0 0 2 1 4 20 3 21 6 26 4 11 7 11 9 9 2 1v2l6 2 2 2 5 2v1h-11l-7-1 7 8 3 3-6 2 2 4 8 1h15l18-2 15-4 5-3h5l1 2-3 3-12 5-13 3-12 2h-22l2 4 5 2 3 1 2 4-2 1 7 2 9 1 2 2-10 9-2 4h-2l-2 6-3 3-1-3-1-11-3-8-3-7-5-9-3-2-3-5-3-3-1-4-2-1-6-11-5-8v-2h-2l-3-6-2-6v-4h-2l-3-10v-4h-2v-2l-6 2-5 8-10 11-8 7-14 11-3 2h-6l-1 3h-2v2l-9 2v2l-21 6-2 1h-9l5-6-4 2 2-4 4-5h2l9-18 4-11 2-11-4 3-2-3-3 3-1 4-10 5-3-1 4-3h2v-2h2v-2l-2-1 16-9 6-7 1-3h2v17l-4 13-7 13-6 9v1l14-5 16-8 12-7 13-10 10-10 7-10 4-9 4-19v-14z",
    fill: "#8E5F3D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,558)",
    d: "m0 0h21l8 2 4 2 1 5 4 2 2 7v16l-2 21-8 4-5 2-6 1h-13l-15-3-8-4-2-3-11-4-3-3v-12l3-8 2-8 2-4h10v-3h3l1 2 4 1h28l13-1-7-2-2-3-4-1 1 5h-21l-1-4-4 2h-6l-1-4 1-3z",
    fill: "#4C555D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,592)",
    d: "m0 0 9 3 13 6 20 8 3 2v2l-17 5-36 12-44 14-24 7-66 22-9 1v-2l47-17 32-12 1-12-36 12-8 3h-3v2l-8 1v2l-11 2v2l-12 3-5 3-4-1-7 1v-6l3-3 30-11 36-12 23-9 2-2 9 2 20 4h4l1-3 13-1 12-3 10-4z",
    fill: "#DAB683"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,330)",
    d: "m0 0 1 2 5-1 24 4 21 4 18 2 6 2 11 2 13 1 7 2 10 1 7 2 20 2v2l12 1 36 6 18 2 1-2 5 3 6 2 3 5 3 2-15 7-15-1-27-4-14-3-16-3-19-3-13-3-117-22-2-1 1-3 5-2h5z",
    fill: "#BEC6CB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,475)",
    d: "m0 0h6l2 7 3 17v8l-5 3-12 4-22 5-26 5-12 1v6h-2l-3 10h-2l1-7 2-5-1-7-2-10-5-10-3-3v-4l3-1v-4l-8 6h-3v5l-2-4 2-7 5-5 8-3h7l8 4 3 2 12-3 1-1 7-1 2-3 3 1h7l23-5z",
    fill: "#F1C399"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(401,493)",
    d: "m0 0 2 2 4 21 10 54 7 36 1 5v10l-8-1-7-3-33-10-7-3-14-3-13-4-15-5-20-6-2-1 1-14 4-25 3 1 1 4 2 9v15l1 5 9 2 5 2 11 1 3 2h3l16 4 10 2 7 1 1-2h2v-6l2-6 4-1v-8l3-3 4 1 2-4 1-13-1-9 1-9v-17l-2-6v-16z",
    fill: "#3F464D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,373)",
    d: "m0 0 3 1v16l1 3 2 1v3l1 4 1 10 2 18 1 5-1 2 2 1-1 3v6l-1 7-1 10-1 7-3 11 3 7 4 2v4l-1 3 4 1-1 2-2-1 1 4-1 2h3v2h2l2 7-1 8 1 3 2 1-2 8 3 12v8l2 1-1 6v4l-5 5 1 7v8h-2l-4-21-11-58-7-43-7-38-4-26-1-18z",
    fill: "#778DA6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,688)",
    d: "m0 0h2v2l5 2 10 6 11 6-2 1-2 74-1 20-5 5-14 8-8 1 3-1-1-6v-35l1-77z",
    fill: "#D9B582"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,470)",
    d: "m0 0 17 2 12 2 7 1-3 2 1 1-1 8-2 39-3 20-4 16-3 9-2-4-2-19-3-10-4 2-14 9-8 4-24 8h-13l-9-3-7-1-6-3v-4l2-1 21-2 21-5 15-5 15-8 8-6 1-8 1-10h-2l-2-7 1-3-2-2-3-7-5-10z",
    fill: "#687382"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,761)",
    d: "m0 0h5v122l-7-1-12-8-2-14-3-43-1-18-2-15v-16z",
    fill: "#746151"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,778)",
    d: "m0 0h7l2 6v13l-1 15-4 4-8 1-10 11-14 8-12 5-7 1h-14l-8-4-3-3 2-5 10-8 8-7h2l1-3h2l1-3h2l2-4 9-12 3-5 8-3 8 1 4 2v3l10-5 2-5-4 1-2 5-5 1v-5l-7 2v-2z",
    fill: "#181213"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(74,362)",
    d: "m0 0 9 2 11 1 13 3 10 1 3 19 6 54 1 2-9-1-15-6-10-3-1-3h-2l-2-10-7-49h-2v-2l-3-1z",
    fill: "#090D10"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,484)",
    d: "m0 0h6l9 6v2l3 1 6 7 10 7-2 1-8-4h-12l-9 4-5 5-6 11v6l1 4 4-2 5-8 5-5 8-3h14l1 2-14 4-8 4-4 5-3 6v3l5-1 10-6 13-1 1 2-4 4-4 3h-2v2l-5 5-2 4 9-5 9-6h28l12-2 18-6 18-3 19-3h10l-4 3-16 2h-5l2 4 3 2v2l6 2 2 2 1 2 5 3 7-1 2-4 3-1 14 2v1l-7 1v6l-20 1-10 2-6 3-1 7v2l-6-1-16-8-1-3 15-3 5-4h2l-3-7-1-1v-8l-28 6-7 3-13 2h-23l-10 4-5 4-3 1 11 5 10 3 17 8 10 4 3 2v5l-10 5-14 6h-7l-13-5v-1l15-2 7-4 9-2v-3l-12-5-6-3-10-3-4-2-1-3-7-3-7-2-6-4-7-3-8-6-4-8-3-2-3-11v-3h10v2l3-3h3l2-5 3-3 12-6 6-1-3-5-7-4-3-2-7 1-9 6-4 3h-4v-2l8-6 9-6z",
    fill: "#BC884D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,647)",
    d: "m0 0h7l1 2-2 8-8 4-27 7-18 6-8 2-17 6-24 8-63 20-17 5-10 6-10 4-7 3-16 5-9 3-9 2-8 2-12 2-23 5-5 1 1-2h3v-2l11-5 7-3 4-1v-2l13-4 19-7 15-7 17-4 25-2 18-7 7-4 13-3 1-2 14-2 10-3 7-4v-2l4-2 8-5 5-1h7l2 1 1-2 9-2 7-3h5l5-3 17-6 9-5 19-6z",
    fill: "#AC845E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,308)",
    d: "m0 0 5 1 10 6v15l-4 18-8 20-5 9-4 8-6-2-16-8-8-3-6 1-3 4h-2l-1 12-4-1-3-6v-11l3-7 1-2h10l6 1 7-7 9-14 8-20 1-1 1-8z",
    fill: "#EBFBFD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,639)",
    d: "m0 0h16l23 6 9 4 21 10 4 3-1 3-16 4-15 5-16 4h-24l-9-7-4-4-4-12-1-5v-9l2 2h6z",
    fill: "#ECFCFE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,550)",
    d: "m0 0 3 2h5l4 3 14 7 17 10 8 4 14 1 10 2 4 2v2l-20 4-49 5h-29l-7-4 1-5 5-9 12-16 5-5h2z",
    fill: "#484440"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,139)",
    d: "m0 0 2 3 3 11 6 31v20h-2l-1 5-7 10-4 6-2 7-3 11-2 2-2 7-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 2 2-1 3-5-4-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-3-1h-7l-5 3-19-2-2-2 2-2-1-3h-5l-5-5v-2l22-1 22-4 13-5 4-1v-3l-7 1-7 3-16 4-13 1h-17l-7-2-1-4 3-2 21 1 21-3 13-4 16-8 8-6v-15l-5-27-2-9z",
    fill: "#5B4433"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,484)",
    d: "m0 0 2 3 5 16 11 33v17l3 27-5 8-14 6-13 4-15 3-30 3-27 1-8-4-6-8 1-4h2l1-3 4 4 3 1h29l49-5 17-3h3l-1-2-6-2-14-2v-2l15-8 4-2-5-39-1-12-3-15z",
    fill: "#D8B583"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,528)",
    d: "m0 0h4v30l-2 13-1 6 6 2 9 5 4 1-1 4-6-2-23-12-22-12-33-17-4-2v8h-1v-9l11-4 36-8z",
    fill: "#DAB683"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(541,467)",
    d: "m0 0h2l7 28 5 9 1 3-11 4-15 1-12-5-6-3v-2l-6-2-11-8-12-10v-2l15-4 25-5 7-2z",
    fill: "#F8F7F6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,530)",
    d: "m0 0 4 2 4 8 10 7 7 3 5 3 9 3 4 2v3l4 1 12 4 10 5 7 3-1 3-13 5-7 3-9 1 2 2-5-1-7-3v-2l-10-1-11-2h-5l2 16h19l3 2-2 4-5 3h-3l-1 3-2 1h-9l-1-8-1-1-3-22v-9l5 2v2l4 1 10 5 16 5-2-2-5-2-11-5-11-4-3-2v-2l-4-1-3-13z",
    fill: "#9BA4AE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,167)",
    d: "m0 0h5v2h2l3 11v3h2l4 12 1 4h2l11 18v3l3 1 2 5 4 4 1 3 5 5 3 6 6 15v11l2 1-2 6h-1l-2-12-4-10-5-12-9-13-8-11-8-13-6-12-5-13-2-10h-2l-2 5-19 19-18 13-21 12-12 5-16 3h-17l2-4 10-11 10-15 9-19v-1l-8 7-8 6-14 9-22 12-7 4-5 2-8 5-7 4-4 5-7 5-3-6 4 1 7-6 3-2 1-3 10-4 4-4 6-3 10-3 7-4h2v-4l-2-3 2-5v-2l-4 2-1-3 20-8 11-5h3v2h-2v2l-5 3 9-3 3-3 1-3h2l1-3 2 1 1 2 4-3-3 15-3 8-5 9-2 5-3 4h-2l-2 4-2 3 3-1-2 4-2 2h7l18-6h5v-2l9-2v-2l3-3h2l1-2v2l9-5 13-11 8-7 9-10 4-7z",
    fill: "#291E1B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,339)",
    d: "m0 0 1 2 28 5 64 12 21 4-3 2v5l-11-1h-14l-13-2-11-2-19-1-14 3-11 6-2 9 1 14 2 14 3 24-2-1-2-12-3-9-3-16-4-20-2-12-5-18z",
    fill: "#4C565E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,297)",
    d: "m0 0 30 1 19 3 19 5 17 7 6 2v2h4l1 4-6-2-3 2v2h-4l-1 4-9-2-11-4-18-6-10-2-2-1-28-2h-20l-28 2-10 3h-3l1-5 7-5 18-5 15-2z",
    fill: "#768DA5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,134)",
    d: "m0 0h2l2 12 1 4 2-3 4 20 4 12 7 12 10 10 2 1v2l6 2 2 2 5 2v1h-11l-7-1 7 8 3 3-6 2 2 4 8 1h15l18-2 15-4 5-3h5l1 2-3 3-12 5-13 3-12 2h-22l2 4 5 2 3 1 2 4-2 1 7 2 9 1 2 2-10 9-2 4h-2l-2 6-3 3-1-3-1-11-3-8-3-7-5-9-3-2-3-5-3-3-1-4-2-1-6-11-5-8v-2h-2l-3-6-2-6v-4h-2l-6-21 1-13-1-2z",
    fill: "#8C5E3D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,603)",
    d: "m0 0h1v15l-2 5-8 9-15 8-22 7-28 7-1 15-5 1-13-2-1 2v-3h4l-1-13-11-1-1-5 9-2 9-4 8-3h3v-12h1v10l11-3 24-6 6-1v-2l4 1 1-2 5-2 12-6 8-6h2z",
    fill: "#4E647C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,254)",
    d: "m0 0h20l27 5 33 7 12 3 14 3 23 5-3 1 3 6-8 4-15-1-36-8-18-5-11-3-11-2-6-2-25-5-8-3-2-2z",
    fill: "#646A70"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,710)",
    d: "m0 0 10 2 9 2 5 2 19 5 7 2 9 4 1 12 4 4 2 3v8l-6 7-2 1h-12l-5-3-3-5v-9l3-5v-4h-4l-3-4-10-1-15-2-9 2-4-1-2-6 2-4v-3l-5-1-1 2-1-3v-3z",
    fill: "#273038"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(156,278)",
    d: "m0 0 10 1 4 2 2 17 2 11 1 13v14l-12 3 3 8 4 18v6l-8-6-3-7-1-13-1-6-1-9-1-1-1-11-5-17-1-1v-7l2-3h-6v-2h-5v-1h12l7-4-2-2z",
    fill: "#3F464D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,631)",
    d: "m0 0h4v12l-9 4-30 11-24 9-23 8-13 4-2-1v-13l-2-1 14-1v-2l8-2 3-2 12-2v-2l6-2h5v-2l8-1v-2l37-13z",
    fill: "#6A3C27"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(360,232)",
    d: "m0 0h7l12 5 6 5 2 4v5l-6-2-10-4h-9l-12 3 3 15v4l7-5 6-2 6 1 7 4 5 5v2l-9-3 2 6 8 1v11l-5 5h-6l-3-2v-2h-2l-1-3v-12l2-7h2l-1-2h-6l-7 4v7l3 12 2 16 4 17 4 9 7 12 9 11 10 10v2l3 1v3l-4-2-1-3-4-2-9-10-12-16-6-11-6-20-3-21-9-31-1-3v-16h2v3z",
    fill: "#72513C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(735,588)",
    d: "m0 0 2 4 7 9v9l-15 10-7 3-6 3-4-1v2l-8 3-9 1-7 3-17 3v-12l1-5 11-2 27-8 13-7 9-9z",
    fill: "#1A1E21"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,668)",
    d: "m0 0 19 1 3 2v38l1 2-11 1 1 4-6 2-1 3h-7l-1 5 2 6h-2l-1 3v3l-5 3v-29l6-2 1-40z",
    fill: "#1A1F22"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,546)",
    d: "m0 0 2 2 5 26 3 17 4 20v10l-8-1-7-3-33-10-7-3-14-3-13-4-15-5-20-6-1-2 5-1 4 2 1-2 12 5 9 2 1 3h7l12 4 20 2 3 1 9-1 16 2 1-4 4-1 1-4h2l1-8h-2l-3-9 1-13v-6h-1v-9z",
    fill: "#313A44"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,455)",
    d: "m0 0 12 6 7 1h15l25-4 8 1 8 3 12 8-4 3-26 5-6-2-7-3-13-1-10 3-9 6-4 5-1 2h-2l-5-24z",
    fill: "#EFC298"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,251)",
    d: "m0 0h18l10 3 5 4 5 7 1 7-3-1-4-9-6-5-10-2 4 7 2 5v10l-4 6-5 4-2 1h-13l-7-6-3-5v-11l4-7 3-3-7 5-6 9-1-4 4-8 11-6z",
    fill: "#48535B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 5 2v3l4 2-2 1h-8l4-2v-2l-9-3-14-4-9-1h-36l-20 4-18 6-16 8-14 8-14 10-13 11-8 9-10 13-5 8-3 7-4 2v4h-2l-1 6-6 23-1 10v17l3 23-1 2h-2l-4-18-1-7v-25l4-19 4-11 7-14h2l1-4 4-5 1-3h2l2-5 12-13 12-11 15-11 17-10 12-6 13-5 20-6 13-2h17z",
    fill: "#322722"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,523)",
    d: "m0 0h2l1 4-1 10-9 7-15 8-24 8h-13l-9-3-7-1-6-3v-4l2-1 21-2 21-5 15-5 15-8z",
    fill: "#758DA7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,537)",
    d: "m0 0 5 1v5l-7 5h-2v2l-8 7-11 14-6 9-4 9h-2l1 3v3l4 4v2l7 2 1 1 27-1 30-3 22-5 16-6 5-3 3-6-3-27v-14l4 8 2 19 1 3v13l-3 5-8 6-11 5-15 4-16 4-8 5-1 2 4 1 1 1h7l2 2 7-1-1 3-9 4-1-2-9-1-3-3h-4v-4l2-4 3-2h3v-2l-8 2-7 1h-34l-7-3v-2l-4-2-2-2v-12l4-8 9-14 8-10 9-10 1-3z",
    fill: "#F5EBC3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,340)",
    d: "m0 0h18l14 4 6 3v2h3v2h3v2l5 2 5 5 2 4-4-2v-2l-5-2-11-5-14-4-13-1v2l-10 5-5 8-4 13-2 12-1 18 2 9 3 6v2h-2l-10-20-1-7v-17l4-20 4-10 5-6z",
    fill: "#D1D9E1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,633)",
    d: "m0 0 7 1 17 9 5 2 15 7v2l6 2 10 5 6 2 1 4-9-3-4-1-1 2 5 2 4 1 2 1v2l2 1-9 3 7 2-4 1-9-2-16-8-8-5v-2l-7-1-10-7-9-4 1-2 4 1v-3l-8-4 1-2 9 3h6l1-2-5-1-10-4z",
    fill: "#9DA3AA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,359)",
    d: "m0 0 14 1 4 2h-4l-3 9v11l2 6h3l2-11h2l2-4 3-2 7 1 16 7 9 5 1 2-6-1-17-8-9-3-5 6-2 9 1 6-6-4 9 24 3 11 1 11-5-5-5-10-7-17-7-11-8-16-1-9 1-7z",
    fill: "#9CA3AA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,795)",
    d: "m0 0h2l-1 9-1 5 1 3 2-1v-11h3l1 4v8l-2 3-8-1-4 2v-2l-7 2 1 3-4 2h-3l-1 3-5 1v3l-5 2-2 3h-2l-2 2h-11-3l-3-2-2 2-4-1-2-3 1-5 4-3h7l4-1v-2l5-1v-3l4-4 6-1-1 2 3 1 1-4 10 1v-2h3l-1-3 3-6v-3l5-1v4l4-4 5 2z",
    fill: "#1A1F22"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(369,609)",
    d: "m0 0 3 1v2h6l7 3 16 8 19 10 3 3 13 7 4 3 2 1v3l-6-1-12-6h-3l-1-2h-3l9 6 17 8 9 3v5l-8-1-16-8v-2l-9-3-6-3-15-7-19-10-1-2h8l7 3h3l-3-2v-2l-3 1-1-3-10-2 2-1v-2l-8-2-2 9-2-2z",
    fill: "#CBC9C5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,363)",
    d: "m0 0h3l-1 12-1-3-4 3v18h-9l-2 1h-6l-4-7-4-1-5 1-2 11 2-1h8l1 4v8l-3 5-5-1-1-4 1-2-2-1 1-2-3 2v4l-5 4-2-2-3-11-1-3 1-2-4-1-1-4 14-5 15-8 10-7z",
    fill: "#E4DBD2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,227)",
    d: "m0 0h18l9 4 6 5 3 7v8l-6-1-8-5-13-2-13 1-8 2-13 7h-2v-7l6-8 10-7z",
    fill: "#1D1615"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,516)",
    d: "m0 0 1 3-3 5-14 9-8 4-18 6-18 4-23 2v4l6 2 15 3 1 1 9 1v1l-9 2h-27l-3 1v2h-6v-2h-10l-2 2 1-8-1-2h2l1-3 3 1 1-5-3-1v-2l-2-1 44-1 25-6 15-6 14-8 4-2 2-4z",
    fill: "#4C637D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(140,557)",
    d: "m0 0 7 1 22 12 16 8v1l-5 1-58 1 1-7 6-7 8-7z",
    fill: "#D8B483"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,457)",
    d: "m0 0h3l1 14 2 10 2 19v10l-4 1 1-4v-8l-3-17-1-6-9 1-23 5h-7l-3-1-2 3h-6l2-1v-12l21-6 15-3z",
    fill: "#A08B7E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(123,517)",
    d: "m0 0 5 1 3 2v2h2l5 5 5 3 4 6v2h2l2 5 6 3 2 4 3 1 6 9 2 4 4 1v2h2v6l-6-1-15-9-10-5-5-2-3-3h-6l-1-3 4-4 5-3v-5l-7-3-6-5-3-1z",
    fill: "#0B0F11"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,102)",
    d: "m0 0 2 1 4 20 3 21v7l-2-1-2-7v-9h-2v9l-1 5 1 2-1 12 1 7-1-2-6 2-5 8-10 11-8 7-14 11-5 2 1-5 2-4h2v-3h2l2-4v-4l13-10 10-10 7-10 4-9 4-19v-14z",
    fill: "#644632"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,616)",
    d: "m0 0 3 2-2 3-26 10-36 12-27 10h-2l-1 8 10-2-2 2h-3v2l-13 1 2-1-1-5-11-3-15-8-9-6 4-1 5 3 13 6 4 1-2-3-7-5-12-6-1-2 6 2 8 4 8 2 1 2v6l13-2 36-12 28-10 17-6 7-3z",
    fill: "#F7E584"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,620)",
    d: "m0 0h3l-1 7-5 3-33 12-15 6-17 6-9 3v2l-4 2-4-1-7 1v-6l3-3 30-11 36-12z",
    fill: "#EFA434"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,536)",
    d: "m0 0 7 2 10 2 2 2 1 13-2 2h-9l-4-2v-2h-3l1 10 14 6 6 3v2l-8 1-2-2-7 1-4-3v-4h-5l3-3h-4l-1-2-13-5-5-2v-7l5-1 10 2v-3h3v-5z",
    fill: "#E8BF96"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,533)",
    d: "m0 0h4l1 8 3 4v4l-7 5-15 3-7-1-10-4-12-3-1-3-2-1h2v-2l13-2 10-4z",
    fill: "#F9F8F6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,373)",
    d: "m0 0 9 3 17 8 1 5-9 12-5 6-8-1-9-7-4-11 3-9z",
    fill: "#EBFAFC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,220)",
    d: "m0 0 3 1v2l4 2 13 13-2 4-11 9-6 5-4-1v-2h-2v-2l-4-2-11-9v-2l8-7z",
    fill: "#FBFAF9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,527)",
    d: "m0 0h10l-4 3-16 2h-5l2 4 3 2v2l6 2 2 2 1 2 5 3 7-1 2-4 3-1 14 2v1l-7 1v6l-20 1-10 2-6 3-1 7v2l-6-1-16-8-1-3 15-3 5-4h2l-3-7-1-1v-9l-2-1 7-2z",
    fill: "#506379"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,255)",
    d: "m0 0h7l7 4 5 6 1 3v9l-3 6-4 4-8 4-7 1h-10l-9-3-8-5-4-7v-11l6-7 4-3h2l-1 3h-2l-2 5-1 2v11l6 8 3 2h13l6-4 4-6v-10l-3-7-2-2z",
    fill: "#F4F3F2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,170)",
    d: "m0 0 2 1 1 5-12 11-12 8-15 9-22 12-5 2-8 5-7 4-4 5-7 5-3-6 4 1 7-6 3-2 1-3 10-4 4-4 6-3 10-3 7-4h2v-4l-2-3 2-5v-2l-4 2-1-3 20-8 11-5h3v2h-2v2l-5 3 9-3 3-3 1-3h2z",
    fill: "#5F4532"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,576)",
    d: "m0 0 15 2 7 3v2l-20 4-13 1-2-2-18 1-8 2-35-1-1-2 2-4 4-3h5v2l13-1 45-1 2-2z",
    fill: "#6A6C71"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,475)",
    d: "m0 0 4 1 1 3 3 1 1 4-1 2h-2l-1 4 2 5h2v2h17v2h3l1 11h5v1l-15 1-12-5-6-3v-2l-6-2-5-4 1-2-1-6v-6l2-5z",
    fill: "#E4DBD3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,488)",
    d: "m0 0h5l10 6 3 3v3l-13 5-8 6-2 4h-3l-1 3h-2v-2h-11v-12h2l1-4 11-7z",
    fill: "#E7E2DD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,227)",
    d: "m0 0h5l1 8-3 9-3 8-1 22-2 10-8 12-10 10v2l6 3 7 4 12 3 13 5 12 6 11 7 2 2-1 3-5-4-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8 4-11v-16l-2-7-5-4-7-2v-1h5l1-3 8-3 3-1 1-4h2v-2l-4 2-6 2-1 1h-5l1-4 10-4z",
    fill: "#855E42"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,543)",
    d: "m0 0h12l11 1 1 4 18 5 4 3-11-2h-6l-6 2-4 1-7 1h-5l-1 3 7 3-3 1-9-4-9-3-11-4 1-2 7-4 8-4z",
    fill: "#DAB683"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,231)",
    d: "m0 0 2 1-5 6h-2v4l-7 4-12 12 6 7 1 3 4 2 4 4 4-1 12-8 2-5 1-2 5-2 9-8v3l-7 7h-2v3l4 1 1 2h-2v2l3 1h-5l-2-2-4 1-8 7-4 5 2 4 3 5 1 3-3-1-1-2-8-1-5 3 1-4v-3l1-1-2-2 2-1-2-4-5-5-2-4-4-2-3-1-4 4h-2l-2 4-8 8-2 1v2l5 5 1 3-5-2-2-2-5 1-5 3 2-6 4-2-1-3-6-5 1-2 6 3v2l5-2 9-7 7-8-5-4-3-5-1-2 6 3v2h2l1 2 4-1 11-9 5-4 1-3-1-2 7-3z",
    fill: "#E7E4E3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,329)",
    d: "m0 0 3 3 4 7 10 13 9 10 5 5 4 2 4-3 2 2v3l-5 2-5-1-2-5-6-1-5-3-1 1h-6l1-3-1-4 1-6-5-2-2 2h-10l-7-1 1-3h2v-2h-5l-1-9 4-3 11-1z",
    fill: "#E5DDD4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,813)",
    d: "m0 0 6 1v2l-8 1-10 11-14 8-12 5-7 1h-14l-8-4-3-3 2-5 10-8 2 1-2 8 2 3 4-1h3l2 2 2-2v2l7-1h4l2-2 3-1v-2l6-1v-3h3l1-2 8-5v-2l7-2h2z",
    fill: "#191516"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(48,552)",
    d: "m0 0 9 2 14 7 6 4 5 1-2 11 6 2 9 5 4 1-1 4-6-2-23-12-22-12-4-2v-3l-4-2 3-3z",
    fill: "#C6A67E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,332)",
    d: "m0 0h9v46l-2 2-4-1-2 2-6-36v-8l2-4z",
    fill: "#F6F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,353)",
    d: "m0 0 8 6 6 7 4 4 1 2 5 5 7 10 5 9 4 8 4 12 7 18 3 9 2 7 1 6 3 8v8l-3-4-11-30-9-27-6-9-4-10-5-9-8-12-9-11v-2l-4-2z",
    fill: "#556B8E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,653)",
    d: "m0 0h10l1 1v13h-4v43l-1 1h-7v-53z",
    fill: "#F2F0EE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,594)",
    d: "m0 0 7 7v9l-15 10-7 3-6 3-4-1v2l-8 3-9 1-7 3-9 2h-6l2-2 12-3 7-2 10-3 1-3 8-4h2v-2l5-3h2v-2h2l2-5 4-5h2l1-5z",
    fill: "#30363A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,553)",
    d: "m0 0h18l14 3 6 4v7l-5 1-1-1v-5l-12-3h-21l-11 1v7l10-2 1 3 21 1-1-5 5 1 1 3 8 1-1 2-13 1h-28l-5-2v-2h-3l-1-7 5-5 5-2z",
    fill: "#E0E1E1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,555)",
    d: "m0 0 8 1 7 3 9 3 15 7 10 4 3 2v5l-10 5-14 6h-7l-13-5v-1l15-2 7-4 9-2v-3l-12-5-6-3-10-3-4-2-1-3-6-2z",
    fill: "#6C82A9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,738)",
    d: "m0 0 3 1 7 2 6-1 4 6v8l-6 7-2 1h-12l-5-3-3-5v-9l2 2 2-4 3-1z",
    fill: "#333C46"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,553)",
    d: "m0 0 11 1 9 3v4h-2l-2 4-13 4h-2v2l-5 1-12-5-2-2-1-2-6-2 3-1v-2l12-2 5-1z",
    fill: "#C7A882"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,411)",
    d: "m0 0 3 3 1 7 4 4v9l1 2 1 16 3 13 7 14 7 4 4 5-1 3-15 2v15h-1l-3-27-2-10-2-21-5-20-2-10z",
    fill: "#607AB0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,607)",
    d: "m0 0 4 1-12 6h20l11-3h3l-1 3-16 8-10 4-5 1h-8l-3-1-1-3-8-4 1-3 6-3h2v-2l5-3z",
    fill: "#E0B376"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,389)",
    d: "m0 0 6 1 9 3 11 1v2h-2l-1 9-1 10-17-1v6l-2-3-2-19-1-1z",
    fill: "#E2DAD2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,482)",
    d: "m0 0h7l8 4 4 6-1 6-4 4h-7l-5 2h-3l-4-5v-4l3-1v-4l-8 6h-3v5l-2-4 2-7 5-5z",
    fill: "#F4F4F4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,655)",
    d: "m0 0 2 4 4 10 8 10 2 2-12-1-15-5-13-5 4-2 4-1-3-3v-2h-2l1-3 11-2 6 2 3-1z",
    fill: "#6D7682"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,536)",
    d: "m0 0 3 1 2 13v7l-2-2-3-10v-3l-7 3-5 3h-2v2l-16 7-13 4-17 4-24 2-19 7-6 1-2-6 3-6h12v2l5 1v-2l-3-1 12-1h21l21-5 12-5 10-4 12-7z",
    fill: "#363E46"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,586)",
    d: "m0 0 5 4 3 1 22 1-1 4 10 1 5 6-6 1-27 1-8-4-6-8 1-4h2z",
    fill: "#C1A37F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(360,232)",
    d: "m0 0h7l12 5 6 5 2 4v5l-6-2-10-4h-9l-10 3-3 3h-2l-1-13 5-1v-2z",
    fill: "#1E1817"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,639)",
    d: "m0 0h9l-3 1v2l-30 9-66 22-9 1v-2l77-28 13-2 5-2z",
    fill: "#ECD9AE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,471)",
    d: "m0 0 13 1 10 5 8 7 14 11 12 7v2l6 2 12 5 15-1 21-7 8-2 4 1-6 3-13 4-17 4-2 1h-11l-14-6-21-13-12-11-8-6-7-2h-15l-9 4h-2v2l-5 3-5 8h3l-1 3-3 2-1-10h2l2-5 8-7 9-4z",
    fill: "#764930"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,627)",
    d: "m0 0h8l7 3 2 1 7 1 14 7 4 4 9 5 14 7 9 3v5l-8-1-16-8v-2l-9-3-6-3-15-7-19-10z",
    fill: "#C1C5C6"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,663)",
    d: "m0 0 7 4 4 2v2l5 1 3 1v2l6 2 14 7 13 6 17 5v2l4 1-5 1-12-3 3 2-5 1-5-2-23-12-22-12-2-2-3-4h3z",
    fill: "#C5A47C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,537)",
    d: "m0 0 5 1v5l-7 5h-2v2l-8 7-11 14-6 9-4 9h-2l1 3v3l4 4v2l7 2 1 1h16l-3 2 1 2h-16l-7-3v-2l-4-2-2-2v-12l4-8 9-14 8-10 9-10 1-3z",
    fill: "#E7E8E9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,527)",
    d: "m0 0 2 4 2 3-1 8h2v2l-6 6h-5l-7-5-2-3-5-2-5-6v-2l21-3z",
    fill: "#6079B0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,490)",
    d: "m0 0h2l1 4-4 1 2 5 4 5 4 10 2 9v7l-3 6-2-3-2-5v-2h-5v-1h5l-4-7-7-9-4-7 2-7 7-4z",
    fill: "#9AA3AE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,80)",
    d: "m0 0 3 1-17 7-16 8-14 10-11 10-6 9h-2l-2 5-7 14-4 13-1 5-1 22-2 1v-6l-1-4 1-18 2-9 9-19 8-12 9-10 12-9 14-8 20-8z",
    fill: "#683B26"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,388)",
    d: "m0 0 4 2 4 8 2 6v7l-4 8-4 4-5-1-8-22-1-1-1 5h-1v-7h3l3 4 3 8 2-9v-9z",
    fill: "#F3F4F4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,155)",
    d: "m0 0h2v17l-4 13-7 13-4 5-4 2 1-4 6-12 4-18-4 3-2-3-3 3-1 4-10 5-3-1 4-3h2v-2h2v-2l-2-1 16-9 6-7z",
    fill: "#6C402A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,520)",
    d: "m0 0 19 1 1 7-2 5 2 1-1 4 1 2-7 3h-4l-1-5h-7l-1-1z",
    fill: "#E8E6E5"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(9,601)",
    d: "m0 0 8 1 2 1 1 17-11 1h-9v-18z",
    fill: "#E7E5E4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,543)",
    d: "m0 0 1 2h2v3l-7 4-4-1-2-1-1 4-13 4-14-1-2-1v-3l-4-1 1-2 13-3h12l12-3z",
    fill: "#86A0E2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,558)",
    d: "m0 0h21l8 2 4 3-6 2h-3l-4-1 1 5h-21l-1-4-4 2h-6l-1-4 1-3z",
    fill: "#5B5B5C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,437)",
    d: "m0 0h10l7 1 1 3h-2l2 6 4 4-5 5-5 2-7-1-2-1v-2h-2l-2-6v-9z",
    fill: "#E7E5E3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,320)",
    d: "m0 0 1 2-5 13-3 11-5 12 3 2 7 1v2l-10-1-11-2h-8l-3-2 13-10 10-9 8-14z",
    fill: "#AB835D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,170)",
    d: "m0 0 1 2-4 17-7 13-2 5-3 4h-2l-2 4-7 8-1 2h13l-1 2-4 1h-17l2-4 10-11 10-15 9-19 2-6z",
    fill: "#201817"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1 20 5v2l6 1 5 2v3l4 2-2 1h-8l4-2v-2l-9-3-14-4-9-1h-36l-20 4-19 6-1-3 18-6 10-3 13-2h17z",
    fill: "#403732"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,600)",
    d: "m0 0 4 1-12 2h13v1l-10 3-6 4-1 2 4 1 1 1h7l2 2 7-1-1 3-9 4-1-2-9-1-3-3h-4v-4l2-4 3-2h3v-2l-8 2-7 1h-18l-3-2 5-2z",
    fill: "#EDE4CE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,478)",
    d: "m0 0h1l-1 8-2 39-3 20-6 24-2-4 2-13 2-10 1-15 1-4 2-38h4z",
    fill: "#9DA5AE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,384)",
    d: "m0 0 5 1 5 3 2-4 1 5-9 12-5 6-8-1-9-7-4-11 3-3 3 11 4 3v2l4-1-1-4h3l2-4z",
    fill: "#D4DCE3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,645)",
    d: "m0 0h20l-1 11 1 1v5h-20z",
    fill: "#E8E5E3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,605)",
    d: "m0 0 12 4 5 5 13 4 16 2v1l-13 1-1 2-5 1-24-5-3-2v-2h-2l1-6z",
    fill: "#C5A680"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,544)",
    d: "m0 0 1 2h5v10l-3 15-9-2-12-6v-10h3l1 2 3 1h9l1-1z",
    fill: "#36414A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,391)",
    d: "m0 0 5 1v6l2-1h8l1 4v8l-3 5-5-1-1-4 1-2-2-1 1-2-3 2v4l-5 4-2-2-3-11-1-3 5-6z",
    fill: "#E8E6E5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,358)",
    d: "m0 0 1 2-27 18-14 8-12 5-9 3h-17l-13-5-2-4 4 1 11 3h17l9-2 16-8 14-8 3-2h3v-2l12-7z",
    fill: "#714C36"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,173)",
    d: "m0 0 3 1-12 14-8 7-14 11-5 2 1-5 2-4h2v-3h2l2-4v-4l11-8 4-1h3l-3 5 3-1 2-4 6-4z",
    fill: "#5C4332"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,260)",
    d: "m0 0h13l1 11-1 2 6-3 1 4-3 6-6 3-5-1-5-5-1-6z",
    fill: "#2F3A45"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,552)",
    d: "m0 0 4 1 6 3-4 2-9 9-5 4-4 8-9 3-2 5-1-2h-2l1-4 3-5 3-2 3-6 8-9 4-5z",
    fill: "#42403F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,312)",
    d: "m0 0h15l2 1v4l3 2-1 10-1 1h-15l-3-1z",
    fill: "#E8E6E5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(516,199)",
    d: "m0 0 4 5 8 13v3l3 1 2 5 4 4 1 3 5 5 3 6 6 15v11l2 1-2 6h-1l-2-12-4-10-5-12-9-13-8-11-7-11v-5z",
    fill: "#302622"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,265)",
    d: "m0 0 5 4h-2l2 6 8 1v11l-5 5h-6l-3-2v-2h-2l-1-3v-12l2-7z",
    fill: "#3C4855"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,263)",
    d: "m0 0h6l1 3h-2l-1 7v15h2l5 5-1 1h-8l-6-4-4-15v-7z",
    fill: "#F6F5F4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658,717)",
    d: "m0 0h5v3l3 1v3l-3 1-1 4-3 1-2 7h-3l1 7-6 3-4-1-2 3v-8l5-5v-3l1-3-1-4 2-5h7z",
    fill: "#252E36"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,476)",
    d: "m0 0h10l-2 2 7 3 1 13-3 1h-3l-7 1-2 34-3 12-1-3 2-14 2-39 1-8z",
    fill: "#D3D8DB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,76)",
    d: "m0 0 4 1 9 7v2l4 2 13 17 10 19 4 11v12l-2-4-8-21-9-16-9-11-6-7-2-1v-2l-4-2-4-4h2v-2z",
    fill: "#2E2726"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,149)",
    d: "m0 0 1 3-5 19-1 10v17l3 23-1 2h-2l-4-18-1-7v-25l4-19 2-3 1 3z",
    fill: "#442E26"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1,395)",
    d: "m0 0 12 1 6 4v5l-2 2v5l-4 2-13-1v-17z",
    fill: "#E8E6E5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,353)",
    d: "m0 0h14l2 1v11l-5 1-1 6-12-1v-17z",
    fill: "#E7E5E4"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,575)",
    d: "m0 0h6v28h-9l-3-2v-10l4-14z",
    fill: "#D7B483"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,391)",
    d: "m0 0 1 2h2l4 8v7l2 1 7 20 6 28 4 19 4 20-3-1-4-16-2-12-4-1 3-1-3-16-2-5-2-12-7-22-6-16z",
    fill: "#4C647F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,632)",
    d: "m0 0 7 1-1 2-45 15h-10v-5l9-2 16-5 18-4z",
    fill: "#BF894B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(420,634)",
    d: "m0 0 6 2 8 4 8 2 1 2v6h7l-3 1v3l12-1-1 8 10-2-2 2h-3v2l-13 1 2-1-1-5-11-3-15-8-9-6 4-1 5 3 13 6 4 1-2-3-7-5-12-6z",
    fill: "#D9B583"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(741,483)",
    d: "m0 0h7l-1 5-2 31-1 18-2 5-3 17h-1l-1-12-1-2v-6l3-1-1-5 3-12 1-11v-9l1-6-3-4-1-7z",
    fill: "#6079AF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,68)",
    d: "m0 0 2 1-9 6-6 2v2h-2l-2 4-3 3h-2v2l2 2-13 8-9 6-10 9-3 2 1-4 8-10 7-7 10-8 18-12z",
    fill: "#EFE0B4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(14,477)",
    d: "m0 0 3 1 2 7v5l-5 4-12 1v-2h-2v-15h6v2l6-2z",
    fill: "#E7E5E4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1,436)",
    d: "m0 0 9 2 8 3 2 2-1 5-3 6-15-1-1-1v-15z",
    fill: "#E8E5E3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,416)",
    d: "m0 0h5l1 1h8l4-1-1 16h-2v2l-5 1h-8l-4-9v-2l9-3 1-2h-3v2l-5-1z",
    fill: "#E8E6E5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,212)",
    d: "m0 0v3l-9 5v9l4 1 9 4v2l-9-3h-7l-9 3h-4v-3h-2v8h-1l-1-7h-3l6-7 5-4 10-5 2-2 7-3z",
    fill: "#D6B382"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,176)",
    d: "m0 0v3l-9 19-11 16-3 3-2-1 6-8v-5l-3-4-2-1-4 1v-2l16-10 9-9z",
    fill: "#D7B483"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,282)",
    d: "m0 0h3l-2 5-7 10-9 9v2l6 3 7 4 12 3 13 5 12 6 11 7 2 2-1 3-5-4-7-4-2-1v-2l-9-3-8-4-5-2-14-3-2 2-1-4-10-6-5-1-10 5-10 1 2-2 15-5 8-5h2l2-4 5-5 5-8z",
    fill: "#695C50"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,396)",
    d: "m0 0 8 2v2l3 1 1 2 4 2-2 7-5 2-11 1-3 1 2-11-1-8z",
    fill: "#E6E5E4"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,363)",
    d: "m0 0h3l-1 12-1-3-4 3v18h-9l-2 1h-6l-1-4 5-2v-3l4-3h2l1-4 2-4-2-2 3-5z",
    fill: "#E6E4E3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,362)",
    d: "m0 0h10l2 2v6l2 1-6 3-2 3h-2l-1 12-4-1-3-6v-11l3-7z",
    fill: "#E6F4F6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,605)",
    d: "m0 0h2v2l-6 3-2 3 2 1-2 3 4-1 5 3 8 1 1 4-3 1-1 3-25-13-8-5-5-1v-1l17-1z",
    fill: "#D9B583"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,595)",
    d: "m0 0 8 1 20 6 9 2 13 4 1 2-4 1 1 4-5-2-6-1-3-3v6l-1-4-7-1-6-4-9-4v-2l-7-1z",
    fill: "#F0C398"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,312)",
    d: "m0 0 4 1 3-1h5l3 5 1 4-3 3-2-1v2l2 1-2 4v-2h-8l1 3-5-2-8-4 4-1h1l3-9z",
    fill: "#E4E3E3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,194)",
    d: "m0 0v3l-2 3 6 1 1 2-8-1-12 11-4 4 1 3 8 7 5 4 2 4h-3l-11-11-2-1v-2l-4 1-13 12-4 4h-2l5 5 4 5-4-2-6-4-11 8v-3l3-1 2-4 11-11 8-7 7-8 4-3h2l2-4 8-7v-3z",
    fill: "#DADEE1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,499)",
    d: "m0 0 6 1 2 1 1 5 1 4-2 5-5 2-10-2-3-3 1-5 2-1-1-4z",
    fill: "#E8E6E5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,51)",
    d: "m0 0h25l13 2 15 5 4 2v2l-4 2h-14l-17-10-1-1-21-1z",
    fill: "#F2E4BA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,583)",
    d: "m0 0 5 2 1-2 12 5 9 2 1 3h7l12 4 9 2 10 3 2 4-9-2-14-3-13-4-15-5-20-6-1-2z",
    fill: "#2D2E2D"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,662)",
    d: "m0 0 7 2 19 11 9 4v2l2 1 3 1 21 8v2l5 1v1l-9-1-16-6-26-13v-2l-5-1-3-1-1-4-6-3z",
    fill: "#F3DBB1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,666)",
    d: "m0 0h3v2l4-2 4 4v8h-1l-1-6h-2l1 8-4 5-9 4h-2l1 3 5 3v2l-4-1-8-1v2l-4-1v-3h4l-5-1h-3v-5l2-1 15-1 7-1-2-4 1-5-1-7z",
    fill: "#E7E5E4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,256)",
    d: "m0 0h2l-1 3h-2l-2 5-1 2v11l6 8 3 2h13l4-1 12 1-3 3-10 2h-10l-9-3-8-5-4-7v-11l6-7z",
    fill: "#EEE7C8"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(686,543)",
    d: "m0 0 4 1-11 3-6 2-8 2 3 2v3l16 1 13-3 1-4 3 1 3 2-16 6-4 1h-13l-9-3-7-1-6-3v-4l2-1 21-2z",
    fill: "#637CAF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(314,333)",
    d: "m0 0 6 1 7-1 1 4 2 4h-2l3 5v5h-8l-9-2-1-13z",
    fill: "#E7E5E4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,70)",
    d: "m0 0h3v7l-2 6h-4l-2-3-6-1v3h-3l-5 10-4 1 2-5 4-9-5-1-8-1v-2l15-2 2 2v-2z",
    fill: "#603E2A"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,538)",
    d: "m0 0h3l1 6v12l-24-8v-2l-2-1h2v-2l13-2z",
    fill: "#E5DCD2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,242)",
    d: "m0 0 14 1 7 3 7 4 4 1v-5l2-1 1 5-1 6 2 4v4h-2l-4-6-7-4-7-2-1-2-11-1-12-6z",
    fill: "#DBB786"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,531)",
    d: "m0 0 4 2-28 6-7 3-13 2h-23l-10 4-5 4-3 1 1 2-10-2-9-6 4-1 2 2 6 2v3h4l2-4 13-8h28l12-2 18-6z",
    fill: "#8A5B3B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,651)",
    d: "m0 0 6 1v17l-5 1-13-2-1 2v-3h5v-13z",
    fill: "#4D5760"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,577)",
    d: "m0 0h5l-1 4-8 4-14 6h-7l-13-5v-1l15-2 7-2z",
    fill: "#50647A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,473)",
    d: "m0 0 3 1-9 3h-3l-1 11 1 7h-4l-10-8-6-5v-2l15-4z",
    fill: "#F8F5F2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,363)",
    d: "m0 0 3 1-1 4v10l6 11 4 7v2h2l5 11v2h2l5 15 1 5h-2l-4-7-8-19-7-11-8-16-1-9z",
    fill: "#646F7B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,105)",
    d: "m0 0 2 1-2 5-7 8-6 10-3 7-4 2v4h-2l-1 6-5 7h-1v-7l9-19h2l1-4 4-5 1-3h2l1-3 5-4z",
    fill: "#201D1E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,530)",
    d: "m0 0h5l3 4 1 15h-7l-4-2-5-1 1-10 4-5z",
    fill: "#F4F3F2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(250,539)",
    d: "m0 0h6l4 3 1 13-2 2h-9l-4-2-1-5 3-10z",
    fill: "#F3F3F3"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,553)",
    d: "m0 0h8l-4 3-6 3-1 7v2l-6-1-16-8-1-3 11-2h10z",
    fill: "#23282C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,416)",
    d: "m0 0h11l3 1 3 6-1 3-5 4-2 4-9-2-1-8 1-4z",
    fill: "#E7E4E3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,187)",
    d: "m0 0 2 1-11 8-25 14-11 6-5 2-8 5-7 4-4 5-7 5-3-6 4 1 7-6 3-2 1-3 10-4 4-4 6-3 10-3 16-9 9-6z",
    fill: "#271F1D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,547)",
    d: "m0 0 13 1h4l3 5v11h-3l-1-2-13-5-5-2v-7z",
    fill: "#36404B"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,662)",
    d: "m0 0 4 4-9 3-10 2-4 2-33 7-17 3v-2l-7-2-6-7 1-2 9 7h24l18-5 23-7 6-1z",
    fill: "#CFD7DC"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,532)",
    d: "m0 0 3 4 2 9 1 9 7 11 6 2-1 4 3 1v2l6-1-4 4h-6l-6-3 2-1v-6h-2l-1-2-3-1-8-15-2-16 2 1z",
    fill: "#232C33"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,593)",
    d: "m0 0 1 2h19l3 2-2 4-5 3h-3l-1 3-2 1h-9z",
    fill: "#DDB885"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,220)",
    d: "m0 0 3 1-7 3-5 1 14 1v1l-18 2h-17l-7-2-1-4 3-2 21 1z",
    fill: "#71432B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,211)",
    d: "m0 0h2l-2 4-5 2v2l-7 4-11 3h-20l2-2 10-3 14-5 9-3h6z",
    fill: "#2F211B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,537)",
    d: "m0 0 8 1v2l2 1-1 24-3-1v-2l-4 1-2-1z",
    fill: "#FCFBFA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,785)",
    d: "m0 0 8 1 2 4h-2v3l-4 1v2h-2l-1 3-1-3h-2l-1 2-4-1-1 3-1-2h-2l1 4-4 4-3-5 8-11 3-3z",
    fill: "#101316"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,215)",
    d: "m0 0v3 2l9 2 4 5-4 1h-18l-11 4h-3l-1-4 6-2 4-4z",
    fill: "#DDBC8A"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,553)",
    d: "m0 0h18l14 3 6 4v7l-5 1-1-1v-5l-12-3-16-1-11-2 4-2z",
    fill: "#E1E0DF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,488)",
    d: "m0 0h5l10 6 3 3v3l-8 2-8-1-4-3-5-1v-3l5-5z",
    fill: "#FAF8F5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,102)",
    d: "m0 0 2 1 4 20 3 21v7l-2-1-2-7v-9h-2v9l-1 5 1 2-1 12 1 7-1-2h-4l2-13v-18l1-6v-14z",
    fill: "#735138"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,458)",
    d: "m0 0h11l3 1 1 4-2 4v2h2l1 5-7 1-7-1-2-4 1-4-1-1z",
    fill: "#E7E4E2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,290)",
    d: "m0 0 4 2v2h3v2h7l4-4 2 1-4 6v5l8 8 4 2 3 7-2 3-4 1-1-4v-5l-8-7-3-2-10 2 1-4 3-4-7-10z",
    fill: "#E8E6E5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,452)",
    d: "m0 0 6 2 2 2 4 1v2h26l14-3 8-3 3-1h7l-1 3-9 4-25 4h-15l-7-1-11-6z",
    fill: "#976A47"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,568)",
    d: "m0 0h3l2 4h-5v2l-7 2-4 10-1 5v10l12 3v3h-11l-5-3-1-1v-12l3-8 2-8 2-4h10z",
    fill: "#363533"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,533)",
    d: "m0 0 1 2h4l3 7 1 8h-2l-1 4h-2l-1 4-6 1-2-5 2-4 2-14z",
    fill: "#44413F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,332)",
    d: "m0 0h9v18h-7v-2h-2v-2h-2v-3h-2l-1 2v-8l2-4z",
    fill: "#E6E4E3"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,312)",
    d: "m0 0 4 2 1-2 3 5 2 4 5 2v-8h-4v-2h6l1 5-2 6 3 1 2 7-7-1v-2l-5 1-2-1v-2l-4-1-3-2 1-7-2-4z",
    fill: "#E7E3E0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,139)",
    d: "m0 0 2 3 3 11 6 31v20h-2v2l-6 1 3-5 1-1v-15l-5-27-2-9z",
    fill: "#383330"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,610)",
    d: "m0 0 2 1-6 7-1 3-7 2v2l-6 2h-2l-3 1-5 1h-3l-4 1v2l-9 2-5 3h-3v-2l-6 1h-5l3-2 24-6 6-1v-2l4 1 1-2 5-2 12-6z",
    fill: "#4A545C"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,586)",
    d: "m0 0 5 4 4 2v3h6v3l5 3 2 1 16 1v1l-27 1-8-4-6-8 1-4h2z",
    fill: "#D7B485"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(264,679)",
    d: "m0 0 4 1 15 9 1-1 9 1 15 5 4 1v2l4 1-5 1-12-3 3 2-5 1-5-2-23-12-5-5z",
    fill: "#BB9871"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,342)",
    d: "m0 0h2l5 25 1 8v14l-2-2-3-7v-9h-2l-2-5v-19z",
    fill: "#4E5860"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,233)",
    d: "m0 0h2v3l4 1-5 1 1 5v8h2l1-2 3 14v4l7-5 6-2 6 1 7 4 5 5v2l-5-2-6-4-2-2h-6l-8 5h-2v6h-2l-6-19-2-7z",
    fill: "#363332"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,627)",
    d: "m0 0h1v10l2-1h6v2l2 1-4 2-7 2-3 1-3 3h-3v2l-12 3h-7l-1-4 9-2 9-4 8-3h3z",
    fill: "#51585E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,271)",
    d: "m0 0 4 1 3 9 1 5-2 3h-7l-3-3 1-5 1-4-2-1-2 9-3 2-1-2v-6l3-5z",
    fill: "#E7E4E1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,504)",
    d: "m0 0h1v10l-1 3-8 7-10 6-14 7-9 2 3-4 16-7 7-5h2l1-3 5-5 4-6h2z",
    fill: "#637DAF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,206)",
    d: "m0 0 2 3-2 4-17 9-13 4-7 1v-1l-12-1 2-4 2-2 5-2-2 4-2 2h7l18-6h5v-2l9-2v-2l3-3h2z",
    fill: "#3C2D25"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,348)",
    d: "m0 0h2l7 8 5 6 5 5 4 2 4-3 2 2v3l-5 2-5-1-2-5-6-1-5-3-1 1h-6l1-3-1-4z",
    fill: "#E4E1DE"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,484)",
    d: "m0 0h6l9 6v2l3 1 6 7v2h-9v-2h2l-3-5-7-4-3-2-7 1-9 6-4 3h-4v-2l8-6 9-6z",
    fill: "#956642"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,219)",
    d: "m0 0h5l1 2-3 3-12 5-13 3h-15v-3l25-5 8-3z",
    fill: "#EDDCB1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,477)",
    d: "m0 0h2l-1 8h-4v14l-1 24-1 6-2 20-2 6-1 15-2-4v-15l3-13 1-4 2-26 1-20 2-5 2-1z",
    fill: "#768EA8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,516)",
    d: "m0 0h14l1 2-14 4-8 4-4 5-3 6-5 1-1-3 6-10 6-6z",
    fill: "#996840"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,171)",
    d: "m0 0h2l6 19 4 10h-2v-2l-4-2-4-7-3-3-3-1v-3l-5 3-8 8-2-1 16-16z",
    fill: "#D4B181"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(123,472)",
    d: "m0 0h1v58l-1 20-3-1v-14l2-62z",
    fill: "#404041"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,471)",
    d: "m0 0 13 1 7 3-1 2-7-1h-15l-9 4h-2v2l-5 3-5 8h3l-1 3-3 2-1-10h2l2-5 8-7 9-4z",
    fill: "#BC884B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,579)",
    d: "m0 0 7 1 1 3-20 4-13 1-2-2-18 1-8 2-9-1v-1l17-3 17-1 6-1h18l5-1z",
    fill: "#4F555A"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,550)",
    d: "m0 0 3 2 2 1-6 4-6 8h-2l-5 10-3 1-2 5-2 4h2l-1 3-5-1 1-7 10-14 8-10 3-3h2z",
    fill: "#202528"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(179,313)",
    d: "m0 0 4 1 1 9v6l15 4v1l-10-1-13-1-2-10v-8z",
    fill: "#E5E4E4"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,568)",
    d: "m0 0 5 2v2l4 1 10 5 16 5 2 1v2l4 2-5-1-7-3v-2l-10-1-11-2h-5l1 4v16h-1l-3-22z",
    fill: "#D7B482"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(87,529)",
    d: "m0 0 6 3 1 12-2 4h-2l-1 11-5 1 1-7v-16z",
    fill: "#242D35"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,639)",
    d: "m0 0h9l-3 1v2l-30 9-6 2-4-1h3v-3l-2-1 15-5 9-1 5-2z",
    fill: "#E7CEA0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,520)",
    d: "m0 0 15 1 2 3v4l-2 1h-11l-1 3h4l1 3-5 2-3-1z",
    fill: "#E7E4E2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,778)",
    d: "m0 0h7l2 6v13l-2-3-1 2h-2v-3l-2-1 3-2h-8l-2 1 1-3 5-3 1-4-4 1-2 5-5 1v-5l-7 2v-2z",
    fill: "#1B1F22"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,668)",
    d: "m0 0 19 1 3 2v4l-6 1-5 1-10-2-1 30h-1v-35z",
    fill: "#2F3943"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,310)",
    d: "m0 0 5 4 6 1 7-1-3 6h2l-1 2 2 4v3l-3-1-1-2h-2l-1 3-8-1 1-4 2-1-3-5-4-7z",
    fill: "#E7E5E4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(439,557)",
    d: "m0 0h3l2 8 3 1v2l5 2 13 5 10 5 4 1v2l-10-2-12-5-8-4v-2l-4-1v4h-3l-2-5-2-1v-7z",
    fill: "#758DA8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,411)",
    d: "m0 0 3 3 1 7 4 4v9l1 2 1 16 1 8h-2l-5-22-4-18z",
    fill: "#6C85B3"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(9,552)",
    d: "m0 0h1v21l2 1-3 2 3 2h-12v-16h6v2h2z",
    fill: "#DDDEDF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(50,520)",
    d: "m0 0 8 1 3 2v5l-8 2 3 2-9 2h-5l3-2-2-1-1-8 2-2h3l1 4 5 1v-2h-3z",
    fill: "#E1E2DC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,251)",
    d: "m0 0h18l10 3 5 4 5 7 1 7-3-1-4-9-6-5-12-3h-3l-1 2-15-1 1-3z",
    fill: "#292B2D"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(297,695)",
    d: "m0 0 6 1 14 4 4 5-1 5-8-2-15-8v-2h4z",
    fill: "#EDC196"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,589)",
    d: "m0 0 2 1 1 2-13 6-15 4-14 2h-9l2-2 12-1v-2l18-4z",
    fill: "#F0E7C9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,558)",
    d: "m0 0h21l6 1v1l-12 1-12 2-4 3-10 1-1-4 1-3z",
    fill: "#A79785"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,234)",
    d: "m0 0 1 4-2 6-3 8-1 22-2 8h-2l1-7v-16l-2-7-2-2v-3l6-2 4-10z",
    fill: "#66432F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,536)",
    d: "m0 0 9 3-2 1-3 13h-2l-1-2h-2l-1 2-2-2v-3h-4v-2h3v-5z",
    fill: "#7489A1"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,174)",
    d: "m0 0m-1 1 2 4-16 16-18 13-5 3-3-1 12-9 13-10 5-5z",
    fill: "#1E1717"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,632)",
    d: "m0 0 20 8-1 5-2-2-7-1-6-2 8 5v4l-5-1-7-5z",
    fill: "#C4C4C0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,769)",
    d: "m0 0 3 4v11l-3 8-5 1v-19l2-2h3z",
    fill: "#42494E"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,769)",
    d: "m0 0 2 1v9l-1 4h-2l-1 4-6 2v-10l-2-5-2-1 10-3z",
    fill: "#D6DBDE"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(210,518)",
    d: "m0 0 3 1 4 4v2l3 1v2l2 1-1 4-5 9-2-2-5-17z",
    fill: "#3F454B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,310)",
    d: "m0 0 1 2-5 9-2 2 1 6h-7l-4 1-1-2 3-5v-2l-3-2-1-5h7v6l3-1 3-5z",
    fill: "#E7E5E4"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,80)",
    d: "m0 0 3 1-17 7-16 8-14 10-4 3h-2v-4l10-7 14-8 20-8z",
    fill: "#382C26"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,254)",
    d: "m0 0h4l2 5 2 3-1 6-3 5-3-2-5 2v-11l2-3 4-2z",
    fill: "#515F6F"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,813)",
    d: "m0 0 6 1v2l-8 1-10 11-5 3h-3l1-7 2-3 6-3v-2l7-2h2z",
    fill: "#101214"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,525)",
    d: "m0 0h2v7l-4 20-3 19-1 11-3 1 1-14 1-2 2-18 2-12z",
    fill: "#D1D6DA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,523)",
    d: "m0 0h2l1 4-1 10-3 2-1-7h-6l-9 5-15 5-8 1 3-2 15-5 15-8z",
    fill: "#5F79AF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,629)",
    d: "m0 0h5l-4 3-35 12-5 2h-3v2l-8 1v2l-11 2v2l-12 3-3-1 41-15 16-6 17-6z",
    fill: "#DBB783"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(124,529)",
    d: "m0 0 5 2 4 4 5 1-5 4-4 2-1 4-4 3-1-3v-16z",
    fill: "#1A1F22"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,291)",
    d: "m0 0v3l-4 4h-3v2l3 1v4l4 2-1 3-5-3-10 2 2-8h2l-3-5v-2l4 1v2l5-3z",
    fill: "#E7E5E4"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,76)",
    d: "m0 0 4 1 9 7v2l4 2 10 13v2l-5-1-12-14-2-1v-2l-4-2-4-4h2v-2z",
    fill: "#262222"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,509)",
    d: "m0 0h5l-2 1v2l-12 3-18 5-15 2-8 2h-10v-1l26-5 22-5z",
    fill: "#585756"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,224)",
    d: "m0 0h2l-1 3-5 2v3l2 1-9 6-4 2 4-6-6-2v-2l-3-1 1-2z",
    fill: "#D7B381"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,231)",
    d: "m0 0 2 1-5 6h-2v4l-7 4-12 12 3 4v2l-5-2-2-1-1-3-5-3-3-5-1-2 6 3v2h2l1 2 4-1 11-9 5-4 1-3-1-2 7-3z",
    fill: "#E5E3E2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,234)",
    d: "m0 0 4 4 3 6 6 15v11l2 1-2 6h-1l-2-12-4-10-4-9v-2h2v-2h-2v-3h-2z",
    fill: "#603E2D"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,584)",
    d: "m0 0h2l-1 5-2 2-1 4-6 9-3 4v4l-5 2-2 2 1-7 5-8 1-3h2l2-5h2l2-6z",
    fill: "#F3C59B"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,610)",
    d: "m0 0 3 1v10l-8-1-7-3-11-3v-1l9-1 2-1 4 2 1-2v2l6-2z",
    fill: "#383838"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,528)",
    d: "m0 0h4v30h-2l-1-17-6-8-8-2v-1z",
    fill: "#EBC095"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,538)",
    d: "m0 0 1 2v6l4 1-4 1v7l5 1 13 5 1 3h3v-6h1l1 7-5 1h-4v-4h-13l-3-2-1-13-2-4 1-3z",
    fill: "#999DA1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,615)",
    d: "m0 0h3v2l-14 6-5-1-4-2-8-1v-3h23z",
    fill: "#F5EBC3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,679)",
    d: "m0 0 9 1 2 2 3 1 21 8v2l5 1v1l-9-1-16-6-14-7z",
    fill: "#F4E9C3"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,537)",
    d: "m0 0 5 1v5l-7 5h-2v2l-8 7h-1v-5l6-7 1-3z",
    fill: "#EBECEC"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,193)",
    d: "m0 0 4 2 8 7v2l6 2 2 2 5 2v1h-11l-6-2-3-6-3-4z",
    fill: "#72462D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,554)",
    d: "m0 0h5l3 2 4 2-10 2h-6v7l7-1v2l-5 1-3 2-1-3h-3l-1-7 5-5z",
    fill: "#CECDC9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,633)",
    d: "m0 0 7 1 17 9 5 2 15 7v2l6 2 12 6-3 1-16-8-27-13-8-4-8-3z",
    fill: "#6D7278"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,377)",
    d: "m0 0h5l7 8-1 4-7 1-5-4-1-6z",
    fill: "#FBFBFA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,543)",
    d: "m0 0 15 2v1l-7 1v6h-17l-1-3 6-2 2-4z",
    fill: "#4C647E"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,470)",
    d: "m0 0 6 1 3 2 1 5v13h-2l-8-16z",
    fill: "#E5F0F2"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,269)",
    d: "m0 0h2l4 18 1 16-2-2v7l-2-4-3-21-1-8z",
    fill: "#916748"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,149)",
    d: "m0 0 1 3-5 19-1 10-3-4-1-9 3-14 2-3 1 3z",
    fill: "#5D3F30"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,525)",
    d: "m0 0 2 3 3 15-1 8 1 4v11l-2 4-2-13v-7l-1-3v-10l-2-6z",
    fill: "#404041"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,266)",
    d: "m0 0h10l-1 3-9 3-7 8-9 9 2-6 6-10h2v-2h2l2-4z",
    fill: "#A47344"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,531)",
    d: "m0 0 4 2-28 6-7 3-13 2h-11l3-2 20-3 18-6z",
    fill: "#9C7656"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,363)",
    d: "m0 0 4 2 3 4 7 4 2 4-6-1-12-5-2-1-1-6z",
    fill: "#F8F8F8"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(157,611)",
    d: "m0 0 1 2 4 1 1 1h7l2 2 7-1-1 3-9 4-1-2-9-1-3-3h-4l2-4z",
    fill: "#F2CCA2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(168,288)",
    d: "m0 0 3 2 3 19 1 21h-1l-3-24-3 4-2-6 1-15z",
    fill: "#4E555D"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,583)",
    d: "m0 0 5 2 1-2 12 5 9 2 1 5-25-7-7-3z",
    fill: "#292E33"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,93)",
    d: "m0 0h4v3l2 1-10 6-12 11-2 1 1-4 8-10 7-7z",
    fill: "#EEDA90"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(741,606)",
    d: "m0 0h3v4l-15 10-4 1 4-5h-2l2-6 3-1 1-2z",
    fill: "#313B46"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,381)",
    d: "m0 0 2 2v3l-8 1-1 4-8 2-2 3h-5l-2-4 4-2 16-7z",
    fill: "#F0E3BD"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(286,263)",
    d: "m0 0 4 3v2l4 2 4 4 3 2h-3v4l3 1 2-1 1 2h3l3 5 1 3-3-1-1-2-8-1-5 3 1-4v-3l1-1-2-2 2-1-2-4-5-5-2-4-2-1z",
    fill: "#E8E6E5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,205)",
    d: "m0 0 7 1-3 6h-3-3v4l-2 3h-2v3l-3-1-3-2v-2l6-4 1-2-5 3-3-2 10-5z",
    fill: "#5D402D"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,457)",
    d: "m0 0h3l1 14 2 10 2 19v10l-4 1 1-4v-8l-3-24-1-16-5 1 1-2z",
    fill: "#7A7470"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,234)",
    d: "m0 0 12 2-5 4-11 5h-3l-1-7 5-1v-2z",
    fill: "#1C1F21"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,233)",
    d: "m0 0 2 1 2 18-3 1-2-4v-3h-4l-2-7h2l2-5z",
    fill: "#F3E8C1"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,707)",
    d: "m0 0h1v20h2v-2h3l1 2 7 1v4h-2v-3l-9 2v-2h-2v6h4v2h4l3 6-4-2-5-1-1-2-1 7h-1z",
    fill: "#E3DED7"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,536)",
    d: "m0 0 3 1 2 13v7l-2-2-3-10v-3l-7 3-5 3h-2v2l-6 2v-3l11-6z",
    fill: "#2D353C"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,282)",
    d: "m0 0 5 4 9 4 6 1h13l-3 2-7 2h-12l-8-5-3-4z",
    fill: "#DBB783"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(98,596)",
    d: "m0 0 6 2 1 3 7 2 1 1h16l-3 2 1 2h-16l-7-3v-2l-4-2-2-2z",
    fill: "#DACEC0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,553)",
    d: "m0 0h3l3 4v2h2l2 2 1 2 4 1-1 4-7-1-7-4z",
    fill: "#2B343C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,605)",
    d: "m0 0h2v2l-6 3-5 2-4-1v2l-5 1-7-4-5-1v-1l17-1z",
    fill: "#BC9E7D"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(460,263)",
    d: "m0 0 2 4v10l-3 5-6 1-2-1 2-5z",
    fill: "#50657D"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,568)",
    d: "m0 0h3l2 4h-5v2l-7 2-4 10-1 5-3-1 1-7 2-8 2-4h10z",
    fill: "#343638"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,662)",
    d: "m0 0 4 4-9 3-10 2-4 2-14 2 3-3 23-7 6-1z",
    fill: "#C5CDD2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,493)",
    d: "m0 0h7l6 2-1 5-3 2-9-1-2-4z",
    fill: "#EBF7F7"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,371)",
    d: "m0 0 7 1 16 7 9 5 1 2-6-1-17-8-9-3-5 2 2-4z",
    fill: "#788EB6"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,800)",
    d: "m0 0 9 3 16 10 6 4v2l4 1-3 1-21-12-10-6z",
    fill: "#55493F"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,210)",
    d: "m0 0 1 3-7 11-3 8-2 1v-6l-9 1 3-3 6-3h3v-3l3-2-1-2 2-4h3z",
    fill: "#554439"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,187)",
    d: "m0 0 2 1-11 8-25 14-8 4-3-1 7-5 7-3 13-7 9-6z",
    fill: "#281F1C"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,130)",
    d: "m0 0 1 2-3 5-3 1v4h-2l-1 6-5 7h-1v-7l7-14 3-1h2z",
    fill: "#292626"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,67)",
    d: "m0 0h10v1h-6l3 3 10 6 10 9 7 7h-3l-8-8-10-7-11-6-7-2 4-1 1-1z",
    fill: "#664630"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,303)",
    d: "m0 0 1 4-2 5-1 13 7 2 2-2 4 1-5 4-3 2-6-5-2-3v-10l4-10z",
    fill: "#97704F"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,501)",
    d: "m0 0 4 1-6 3-13 4-17 4-2 1h-11l3-2 13-2 21-7z",
    fill: "#66594E"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,452)",
    d: "m0 0 6 2 2 2 4 1v2l26 1-3 1v2h-15l-7-1-11-6z",
    fill: "#6C4834"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,688)",
    d: "m0 0 9 2 16 6h7l5 1v3h-8l-18-3v-2l-4-2v-2l-7-2z",
    fill: "#EFC297"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,551)",
    d: "m0 0 4 2-2 4-7 9h-3v-9l4-4z",
    fill: "#1C2124"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,60)",
    d: "m0 0h3l-1 3-16 8-10 6-3-1 5-5 12-7z",
    fill: "#2D2422"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,318)",
    d: "m0 0 7 1 15 6 15 9 5 4-1 3-5-4-7-4-2-1v-2l-9-3-8-4-10-4z",
    fill: "#44505E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,227)",
    d: "m0 0 2 2-9 9h-2l5 5 4 5-4-2-6-4-11 8v-3l3-1 2-4 11-11z",
    fill: "#E5E2DF"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,555)",
    d: "m0 0h8l2 1-1 7-5 1-9-5-1-3z",
    fill: "#1A1718"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(82,524)",
    d: "m0 0h4l2 5-2 9v16l-2 7h-1z",
    fill: "#34322F"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,233)",
    d: "m0 0h2v3l4 1-5 1 1 5v8h2l1-2 3 14 1 12-2-2-7-24z",
    fill: "#906A4C"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,484)",
    d: "m0 0 2 3 5 16 2 5v5l-4-1-3-7-2-15z",
    fill: "#EEE3BE"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,305)",
    d: "m0 0 2 1 3 24v5h-3l-1-3-1-9-2-9 1-8z",
    fill: "#313A42"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,426)",
    d: "m0 0 2 2 4 14 3 7 1 7 3 8v5l-2-3-8-21-1-8-2-7z",
    fill: "#4B5865"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,348)",
    d: "m0 0m-1 1 1 2-7 8-6 13h-2l1-10 4-8h2v-2z",
    fill: "#C6CDD2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,292)",
    d: "m0 0 5 2 4 1 4-1-5 5-1 3 5 5-7 2-5-1 2-3 1-8-3-3z",
    fill: "#E8E6E5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(156,278)",
    d: "m0 0 10 1 4 2-1 4v-3h-3l-2 5-2 1h-11l4-3 3-2-2-2z",
    fill: "#4E575F"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,405)",
    d: "m0 0h1v10l-17-1 1-6 4-2 5 3 2 2 1-3h3z",
    fill: "#E8E6E5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,566)",
    d: "m0 0h5l-3 2-16 6-6 1-2-6 3-1 14-1z",
    fill: "#1A1F22"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,745)",
    d: "m0 0h1v24l4-1 3 2-3 2h3l3-3 2 1-8 7h-4l-1 2-1-7z",
    fill: "#EBE9E1"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,664)",
    d: "m0 0 5 1 4 3 22 10 3 2-5 1-12-5-14-8z",
    fill: "#AD8B6B"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,404)",
    d: "m0 0 2 1 4 10 3 11 1 11-5-5 1-2-3-11-3-8z",
    fill: "#A7B4C8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,221)",
    d: "m0 0 4 1 2 5-13 4-5 1-1-4 6-2 4-4z",
    fill: "#F0E2B9"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,182)",
    d: "m0 0h3v9l-7 11-5 3 1-4 6-12z",
    fill: "#885939"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,603)",
    d: "m0 0 6 1 13 4 1 2-4 1 1 4-5-2-6-1-1-5-3-1z",
    fill: "#D1AD7B"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,552)",
    d: "m0 0 4 1-4 6-5 6-7 1 2-5 6-7z",
    fill: "#746F6D"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,404)",
    d: "m0 0 2 3 1 4h2l5 15 1 5h-2l-4-7-7-16z",
    fill: "#6E7986"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,600)",
    d: "m0 0h1v13l-8 4h-7l3-1v-3h2l2-4 4-2z",
    fill: "#454E52"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,583)",
    d: "m0 0 5 2-3 1v2h7l-4 3h-7l-13-5v-1z",
    fill: "#596879"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,596)",
    d: "m0 0h5l1 2h-2v2h-2l1 2 11-1-1 5-3 2h-9z",
    fill: "#F5EBC3"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,499)",
    d: "m0 0 3 1-2 7 2 8h-7l-1-4v-7h2l1-4z",
    fill: "#FBFAF9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,463)",
    d: "m0 0 1 3h2l3 14 3 16-3-1-4-16-2-12-4-1z",
    fill: "#464D55"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(274,333)",
    d: "m0 0h7l5 1-1 3-4 2v5l-8-2-1-3z",
    fill: "#E7E5E4"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,164)",
    d: "m0 0h1v8l-4 13-4 4 1-7h-2l1-10h1l1 5v-4h2l2-8z",
    fill: "#6B3E28"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,51)",
    d: "m0 0h11l-2 2-20 5-12 4-1-3 18-6z",
    fill: "#4B3E34"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,618)",
    d: "m0 0 4 2 9 14 2 5-1 10h-2v3h-3l1-5 2-4-1-9h-2l-5-9-4-4z",
    fill: "#C5A47C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,227)",
    d: "m0 0 5 1-4 3-12 4-7 1-4-2-1-2 17-3z",
    fill: "#6A402A"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,358)",
    d: "m0 0 1 2-27 18-4-1 2-3 9-5h3v-2l12-7z",
    fill: "#3F342E"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,548)",
    d: "m0 0 3 1-1 3-3 7h-2v2h-2v2l-4 2-4-3 1-4 6-1 1-3 2-1 1-3h2z",
    fill: "#303A45"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,149)",
    d: "m0 0h1l-1 13-3 6-4 6-3-1-2 4-4 2 2-5 5-4 6-11 1-1z",
    fill: "#8B5F3E"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,791)",
    d: "m0 0h2v2l4 1-1 5v4l-3 5h-2l-1 2v-13z",
    fill: "#F1EEEB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,639)",
    d: "m0 0h9l-3 1v2l-23 7-4-1h3v-2l5-1 3-3 9-2z",
    fill: "#E7BE8F"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,576)",
    d: "m0 0 7 1 13 7 4 1-1 4-6-2-17-9z",
    fill: "#D6C4AE"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,352)",
    d: "m0 0 3 1-3 4h7l7 2 10 2v2l-10-1-11-2h-8l-3-2z",
    fill: "#796453"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,279)",
    d: "m0 0 8 2 1 5-2 3h-7l-3-3 1-5z",
    fill: "#E8E6E5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,238)",
    d: "m0 0h2l1 5-4 4h-4l-1 2-9-3v-1h5l1-3 8-3z",
    fill: "#91623F"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(204,805)",
    d: "m0 0 4 2 6 4v2h8l5-6 5-2v2l-8 7-1 2h-2v3l-4-1-5-2-4-6-4-3z",
    fill: "#E1DFDE"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,639)",
    d: "m0 0h16l23 6 1 2-7-1-13-4h-10l-8-1-8 3-3-1z",
    fill: "#D2D9DE"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(43,478)",
    d: "m0 0 5 1-1 5h3l2-2v7l-2-2h-3l-1 6h-2l-2-5-1-7z",
    fill: "#E2DFDC"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,780)",
    d: "m0 0 4 1-1 5-9 5h-2v-3l-9-2-2-2 12-1 2 3 3 1 1-6z",
    fill: "#666F79"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,728)",
    d: "m0 0h9l2 2 1 9v3l-3-1-1-3 1-2-4 2-3-4 3-3-5-1z",
    fill: "#1F2427"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,391)",
    d: "m0 0 5 1v6l-2 2-9 1-1-3 5-6z",
    fill: "#E6DED6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(101,593)",
    d: "m0 0 11 5 6 3 1 3h-7l-7-3-4-5z",
    fill: "#3C3733"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,55)",
    d: "m0 0 9 1 6 4v2l9 1 1-2 4-2 2 1v2l-4 2h-14l-12-7z",
    fill: "#EAD37F"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,646)",
    d: "m0 0 9 2 10 4 9 2v1h-7l-10-2-2 1-6-1-4-3 5-1-4-2z",
    fill: "#B89B7C"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,377)",
    d: "m0 0 6 1-5 4-15 7-4-1 3-3 12-6z",
    fill: "#5E4434"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,317)",
    d: "m0 0 1 4-5 12-8 16-8 10v-3l4-7h2l2-6 6-12 4-10z",
    fill: "#9F938B"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,298)",
    d: "m0 0 2 3v2h2l4 17 1 5-4-1-4-14z",
    fill: "#7D563C"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,314)",
    d: "m0 0 14 3 1 4-6-2-3 2v2h-4l-1 4-3-1h2v-6l-1-4z",
    fill: "#657CAE"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(433,256)",
    d: "m0 0h2l-1 3h-2l-2 5-2 10-2-2v5h-3v-11l6-7z",
    fill: "#D9D4C0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,604)",
    d: "m0 0h18v3l-2 1h-18l-3-2z",
    fill: "#F7F1DB"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(111,589)",
    d: "m0 0h31l-4 2-9 1h-19z",
    fill: "#1B2023"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(77,515)",
    d: "m0 0 5 2 2 7h-6l-9-5v-2z",
    fill: "#1B1718"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,469)",
    d: "m0 0 4 1h-3l3 9 7 14 1 5-3-1-8-16-2-6z",
    fill: "#465362"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(544,353)",
    d: "m0 0v3l-4 6-2 2-4-1h2v-2h-7l-3-2 5-5 3 1 4 4 2-4z",
    fill: "#D6B688"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,22)",
    d: "m0 0h2l1 4 3 2-1 7 1 4h-6l-3-3-6 1 1-5 5 1 6 4-1-7 1-2-4 2z",
    fill: "#E7E3E0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,660)",
    d: "m0 0h3v2l-19 7-11 4-6 1v-2z",
    fill: "#EEDDB4"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,601)",
    d: "m0 0 9 2 16 7 1 3h-8l-4-4-5-3h-3v-2l-6-2z",
    fill: "#EABF93"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,566)",
    d: "m0 0 5 1 10 4 8 3 1 1 8 1 1 3h-8l-12-6-10-4z",
    fill: "#6F85A4"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,537)",
    d: "m0 0h1l-1 12-2 6-1 15-2-4v-15l3-12z",
    fill: "#748BA4"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,221)",
    d: "m0 0 9 9 2 4v5h2v3h2v2l-4-2-10-15-2-5z",
    fill: "#251D1C"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,193)",
    d: "m0 0h1l4 28-1 2h-2l-3-13z",
    fill: "#543E32"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,48)",
    d: "m0 0 18 1v2h-41v-1l6-1z",
    fill: "#322B26"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,555)",
    d: "m0 0 8 1 7 3 7 2 1 3-7 1-9-4-1-3-6-2z",
    fill: "#758496"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(698,550)",
    d: "m0 0 3 1 3 2-16 6-4 1h-13l-1-3h14l13-3z",
    fill: "#617AA7"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,527)",
    d: "m0 0h10l-4 3-16 2h-5l2 5-4-1-2-6z",
    fill: "#5D6976"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,496)",
    d: "m0 0 12 6v2l6 2 14 6v1l-8-1-16-8-8-5z",
    fill: "#784C32"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,102)",
    d: "m0 0 2 1 3 14v12l-1 3h-2l-2-23z",
    fill: "#48352C"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,320)",
    d: "m0 0 1 2-5 13-3 11-2 4-2-1 3-9h-2l1-4 8-15z",
    fill: "#926947"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(286,306)",
    d: "m0 0 7 6 4 2 3 7-2 3-4 1-1-4v-5l-8-7-2-2z",
    fill: "#E8E6E5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,92)",
    d: "m0 0m-2 1 2 1v3l-10 10h-3l-6 7v-3l11-12z",
    fill: "#382A24"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,551)",
    d: "m0 0h2v2l2-1h9l2 8-6-1-9-4z",
    fill: "#666F7B"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,458)",
    d: "m0 0h11v1h-5l2 5v5l-6-1-2-3z",
    fill: "#EEEBEA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,312)",
    d: "m0 0 4 2 1-2 3 5 1 6-8-2v2l4 1 2 3-4-1-3-2 1-7-2-4z",
    fill: "#E8E6E5"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,476)",
    d: "m0 0 9 1 3 1v2l-9 2h-7l-2-4z",
    fill: "#AB845F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,353)",
    d: "m0 0 8 6 6 7 4 4 1 2 3 2-1 4-3-1-8-11-5-6v-2l-4-2z",
    fill: "#506075"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,192)",
    d: "m0 0h2l-2 5-15 11-5 3-3-1 12-9z",
    fill: "#241D1C"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,42)",
    d: "m0 0 1 4-2 3v5l7 3 1 2-9-3-4-1v-2h-5v-1h6l1 1 1-2-4-1 1-4 2 1-1-3z",
    fill: "#E0D7CD"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,620)",
    d: "m0 0 1 3-8 9-14 7-3-1 6-4 9-5 7-6z",
    fill: "#3A454F"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,568)",
    d: "m0 0 5 2v2l4 1 8 4v1h-16l-1-5z",
    fill: "#A7AFB7"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,550)",
    d: "m0 0h2v3l-13 5-12 3-3-2 9-3z",
    fill: "#393F45"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,220)",
    d: "m0 0 1 3h2l1-2 2 5v3l4 1 3-2-2 4-3 1v-2l-2 1 3 4 2-1-2 5-3-3-4-8-2-5z",
    fill: "#6E4E40"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(356,113)",
    d: "m0 0 2 3-7 10-5 9h-2l1-6 7-11zm-13 22m-1 1m-1 1m-2 1 2 1-2 1z",
    fill: "#875C3C"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,773)",
    d: "m0 0h6v4h3l-1 4v2l4-1 1-3v4h-2l-1 4-6 2v-10l-2-5z",
    fill: "#E6E5E4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,411)",
    d: "m0 0 3 3 1 7 4 4v7l-4-3-2 1-2-10z",
    fill: "#778FAD"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,264)",
    d: "m0 0 8 1 6 2v3l-8 1-7-1v-2h3v-2l-3 1-2-2z",
    fill: "#68717D"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,68)",
    d: "m0 0h8l9 2v2l-5 1 1 3-4-1-9-5z",
    fill: "#F0D885"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,45)",
    d: "m0 0h2v2l19 1v1h-19l-17 1-3 2-12-1v-1l13-2h17z",
    fill: "#867D74"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,663)",
    d: "m0 0 5 2 13 8v1l-9-1-5-4-4-1-1-3z",
    fill: "#49423D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,626)",
    d: "m0 0 4 1-7 3-9 1-7 3-9 2h-6l2-2 12-3 7-2z",
    fill: "#313A43"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,563)",
    d: "m0 0h12v2l3 2-1 1-14 1-2-2z",
    fill: "#303A44"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(308,549)",
    d: "m0 0h1l1 11-2 11-1 11-3 1 1-14 1-2z",
    fill: "#BDC5CB"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,541)",
    d: "m0 0 6 1-1 4-9 6h-3l1-4 4-5h2z",
    fill: "#EAD5AA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,437)",
    d: "m0 0h11l-2 7-2 1-3-1-3 4z",
    fill: "#E6DFD9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,778)",
    d: "m0 0 3 1v2l2 4-7-1-14 14 2 5-4-2v-4l7-7 5-6 5-4z",
    fill: "#DDDEDE"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,699)",
    d: "m0 0 6 1h5v3l-15 1h-4v-4z",
    fill: "#E7E5E3"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,611)",
    d: "m0 0h3l-1 3-9 5-3-1 4-1v-2l-8 2-18-1v-1l21-1z",
    fill: "#E0BA88"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,484)",
    d: "m0 0 2 2 1 4v12l-2 1-3-6-1-6 1-3h2z",
    fill: "#32373A"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,88)",
    d: "m0 0h2l10 13v2l-5-1-9-11 2-1z",
    fill: "#221D1D"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(215,820)",
    d: "m0 0 7 1 3 3v2l4 2v2l4 2 4 3-1 2-8-6-8-8-6 2-5 5-2-1 7-7z",
    fill: "#E1E0E0"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,788)",
    d: "m0 0h1v16l-1-4-2 1v10l-3 1v-2l-2-1 1-5 1-4 4-6z",
    fill: "#131011"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,672)",
    d: "m0 0 1 2-19 7h-5l1-3 14-5z",
    fill: "#DEB988"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(467,241)",
    d: "m0 0h5l2 2v8l-6-1-3-2 2-5z",
    fill: "#171616"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,472)",
    d: "m0 0h12l7 3-1 2-7-1-17-1 1-2z",
    fill: "#996A44"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(696,413)",
    d: "m0 0 3 1 4 9 3 14 1 4-2 2-7-23z",
    fill: "#4B6077"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,300)",
    d: "m0 0 5 1v3l3 1v2h-7l-7 2 1-4 3-3h2z",
    fill: "#E6DED7"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,253)",
    d: "m0 0 9 2v1l-10 1-5 4-6 9-1-4 4-8z",
    fill: "#4A4744"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,80)",
    d: "m0 0 3 1-17 7-13 6-2-2 12-6z",
    fill: "#895B37"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480)",
    d: "m0 0h9v5l-4 1-1 5-3-1z",
    fill: "#EFEDEA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,518)",
    d: "m0 0 5 5-1 8h-2l-3 10h-2l1-7 2-5z",
    fill: "#C9D0D7"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,250)",
    d: "m0 0h2l-2 4-6 5v2l8 6-2 1-7-4h-5l2-6 8-6z",
    fill: "#E7E3DF"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(475,245)",
    d: "m0 0 2 2-1 9 2 4v4h-2l-4-6-2-2-3-4 4 1 1-1 2-1v-5z",
    fill: "#D7B381"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,583)",
    d: "m0 0 6 2v1h-11l-18 2-2 1-9-1v-1l17-3z",
    fill: "#475158"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,514)",
    d: "m0 0 6 2 3 4v2h14v1l-16 2-4-6-2 3z",
    fill: "#D1B082"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,497)",
    d: "m0 0 3 2-1 1 2 2-1 2 4 1-9 2-4-7v-2z",
    fill: "#66717E"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,415)",
    d: "m0 0 6 1-2 4h-9l-5 2-2 1-1-7h12z",
    fill: "#E7E5E4"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,359)",
    d: "m0 0h9l2 2-3 3-7 2-3 1v-7z",
    fill: "#FCFBFA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(34,312)",
    d: "m0 0 3 2 1 9v6l-2 2-4-11v-2h2l-1-5z",
    fill: "#252E36"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,300)",
    d: "m0 0h4l2 4v3l-4 1-1 1h-6v-4z",
    fill: "#E8E6E5"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,269)",
    d: "m0 0h1l3 10 5 7-4 1-5-5-2-4 1-4z",
    fill: "#F3EDD7"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,796)",
    d: "m0 0 2 1 2 4 6 2 1 2-5-1-4-1-12 11-3 3-2-1 16-16h-4v-2z",
    fill: "#E1E2E3"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,663)",
    d: "m0 0 7 4 4 2v2h2l-1 2h-2v3l-8-4v-2l-3-3h3z",
    fill: "#BE9D78"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,660)",
    d: "m0 0 4 1-36 12-2-1 10-4 19-7z",
    fill: "#DBB685"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(50,520)",
    d: "m0 0 8 1 3 2v5l-7-1-3 1-3-2h5v-2h-3z",
    fill: "#E8E6E5"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(755,478)",
    d: "m0 0 3 1 1 5 4 1v6h-3l-6-2z",
    fill: "#FCFBFA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,866)",
    d: "m0 0h1v32l4-1 5-4 3 1-8 7-5 1z",
    fill: "#E6E0D7"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,546)",
    d: "m0 0 2 2 3 16v4l-4-2-1-4v-6h-1v-9z",
    fill: "#353C43"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,537)",
    d: "m0 0h2l-2 4-6 5-3 3h-3v-5z",
    fill: "#D9B582"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,272)",
    d: "m0 0h2v2h-2l-4 8 4 2v2l-6-1-5 1 1-4 4-2 2-4z",
    fill: "#E8E6E5"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,778)",
    d: "m0 0 3 1-1 2-4 1-2 5-5 1v-5l-7 2v-2z",
    fill: "#454B51"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,769)",
    d: "m0 0 2 3-1 3-2-1-1 5v13l-3 1v-19l2-2h3z",
    fill: "#313539"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,666)",
    d: "m0 0h3v2l4-2 4 4v8h-1l-1-6h-2v2l-6-1v-5z",
    fill: "#E6E3E0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,607)",
    d: "m0 0 4 1-11 5h-8l2-4 1-1z",
    fill: "#F6ECC3"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(737,594)",
    d: "m0 0 7 7v5h-4l-2-6-5-1 2-4z",
    fill: "#2D363D"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(467,501)",
    d: "m0 0h15l8 6-2 1-8-4h-12l-9 4-2-1 5-4z",
    fill: "#A6774C"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,430)",
    d: "m0 0 2 2 3 16 2 5 1 9-2 1-3-12-3-11z",
    fill: "#928783"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,363)",
    d: "m0 0 7 1 6 4h4l3-2 2 2v3l-5 2-5-1-2-5-6-1-4-2z",
    fill: "#E0E1D7"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,334)",
    d: "m0 0h2l3 6-2 6v2l-4-1-3-6 4-4z",
    fill: "#3F464D"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,307)",
    d: "m0 0 4 1 6 3 7 4 10 2v3l-11-2-2 2-1-4-10-6z",
    fill: "#768193"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,263)",
    d: "m0 0 1 2v10l3 7 3 3 10 2v1h-9l-7-6-3-5v-11z",
    fill: "#3A4652"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,248)",
    d: "m0 0v3l-7 7h-2v3l4 1 1 2h-2v2l3 1h-5l-5-4h3l-1-3 3-5z",
    fill: "#E8E6E5"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,253)",
    d: "m0 0 5 2 5 5 4 5 1 7-3-1-4-9-6-5-3-2z",
    fill: "#544A42"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,645)",
    d: "m0 0 1 3-8 1v2l-11 2v2l-12 3-3-1 22-8z",
    fill: "#D2AB77"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,550)",
    d: "m0 0 3 2 2 1-6 4-2 3-4 2-2 2-3 1 2-4 7-8h2z",
    fill: "#414446"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(122,524)",
    d: "m0 0h1l1 6-1 20-3-1v-14z",
    fill: "#42484C"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,516)",
    d: "m0 0h10l-1 2h-5l3 11-1 3-3-2-3-11z",
    fill: "#A6856A"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,260)",
    d: "m0 0 5 1 1 7-1 1-7-1v-6z",
    fill: "#E8EAEC"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,579)",
    d: "m0 0h3l-1 6-2 4h-2l1 3v3l2 4-5-3v-9z",
    fill: "#EAE8E3"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(385,199)",
    d: "m0 0 4 1-4 4-7 4-7 2 2-4h2l1-2 2 1 1-3z",
    fill: "#695849"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,170)",
    d: "m0 0m-3 1 3 1-3 4 1 3-4 6-3-1 3-5-4 2v-3z",
    fill: "#785237"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,139)",
    d: "m0 0h2v9l1 2-1 12 1 7-1-2h-4l2-13z",
    fill: "#513B2D"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,554)",
    d: "m0 0 4 1 3 2-5 2-8 8-3-1 6-8z",
    fill: "#2D2D2C"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,375)",
    d: "m0 0 4 1-3 4-2 9 1 6-6-5v-2h2l2-11h2z",
    fill: "#8DA5DF"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,375)",
    d: "m0 0h7l5 1-2 4-5 2-2-1v-2l-4-1z",
    fill: "#E8E6E5"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(35,370)",
    d: "m0 0 3 1 1 2v19l-2-2-2-15z",
    fill: "#1A191B"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,269)",
    d: "m0 0h2l2 11v7l-2 2-3-9z",
    fill: "#8F6445"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(217,784)",
    d: "m0 0 2 1-3 2-5 2-4 4-5 2-1 1 3 1v3l-5-1 1-6 3-3 5-2 5-3z",
    fill: "#D6D9DB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,652)",
    d: "m0 0h4l1 3 3-2 4 1 1 3-7 2-6-1-1-5z",
    fill: "#FCFBFA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,574)",
    d: "m0 0 9 2 2 1-1 3-10 2v-4l-1-3z",
    fill: "#C2C9CE"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,563)",
    d: "m0 0h7l-3 1 1 5h-21v-1h13v-4z",
    fill: "#858789"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,568)",
    d: "m0 0h2l4 4 6 1 2 1-4 3h-6l-6-3 2-1z",
    fill: "#212223"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,529)",
    d: "m0 0m-1 1m-2 1h2v2l-7 4-15 5-8 1 3-2 15-5z",
    fill: "#607AB1"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,523)",
    d: "m0 0 1 3h3v5l-3 6-2-3-2-5v-2h-5v-1l8-1z",
    fill: "#7F91A6"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,519)",
    d: "m0 0 4 1v4h2v3l-6 2h-3l-4-2v-3h5v3l2-1 1-4z",
    fill: "#E7E5E4"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,484)",
    d: "m0 0h5l1 2v8l-1 2-9-1h-1v-6l6 1 2 1 1-6z",
    fill: "#EBE9E9"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,383)",
    d: "m0 0 7 1-1 3 2 3-3 2-5-1-1-5z",
    fill: "#E7E4E2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,253)",
    d: "m0 0 3 1v2l1 2-5 1-1 3-1-2-9-2 4-3 7 1z",
    fill: "#4B5D71"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,217)",
    d: "m0 0v3l-3 3h7l5-2 4 1-6 3v2l-3-1-12-1 2-4 2-2z",
    fill: "#50392E"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,219)",
    d: "m0 0h5l1 2-3 3-6 2-4-1h-5l3-2 7-3z",
    fill: "#D6B07C"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,590)",
    d: "m0 0 6 1 10 2 8 3 3 2h-7l-12-4-7-1z",
    fill: "#303A44"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,543)",
    d: "m0 0h6l-1 3-5 3-6 1-2-1v-3z",
    fill: "#EFC297"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,508)",
    d: "m0 0h1v15l-2 14-2-1 2-27z",
    fill: "#768EA8"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,312)",
    d: "m0 0h15l2 1-1 3h-10l-6-2z",
    fill: "#E7E4E1"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,170)",
    d: "m0 0 2 1 1 5-11 10-2-1 3-3 1-4 2-2 1-3h2z",
    fill: "#46382F"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(329,151)",
    d: "m0 0 3 3-1 7-3 8-2 3v-10z",
    fill: "#413D3B"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(650,670)",
    d: "m0 0h4l4 5h-6l-1 30h-1z",
    fill: "#2D3439"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,600)",
    d: "m0 0h1v8l9-1 4-3v3h10v1l-12 1-3 2v-2l-8 1-3 1h-5l2-2 4-1z",
    fill: "#D9B586"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,605)",
    d: "m0 0h7v3l-13 5h-5l2-2 8-3-3-2z",
    fill: "#E1BB89"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,577)",
    d: "m0 0 10 2-1 2-5 2h-14l2-2 7-2z",
    fill: "#9DA5AE"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,564)",
    d: "m0 0 5 1 1 3 8 1-1 2-19-1v-1h7z",
    fill: "#F1EFEE"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(241,536)",
    d: "m0 0 9 3-2 1-2 9h-2l-1-2 1-9h-2v2h-3z",
    fill: "#93A0B3"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(149,346)",
    d: "m0 0 2 4 2 17v2h-2l-2-6-1-11z",
    fill: "#1A1F22"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(264,679)",
    d: "m0 0 4 1 17 10-3 2-16-9z",
    fill: "#AE8862"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(455,611)",
    d: "m0 0h2v2h7l-1 3-8 1-4 2h-3v-3l5-3h2z",
    fill: "#ECD2A5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494,571)",
    d: "m0 0 10 1 3 2h-3v2l3 1-2 1-11-2z",
    fill: "#C2C9CE"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,561)",
    d: "m0 0h11l-3 5-2 1h-6l-1-4z",
    fill: "#3F4346"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,538)",
    d: "m0 0 3 1 1 2 1 16-2-2-3-10v-3h-2z",
    fill: "#1C2125"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,260)",
    d: "m0 0 7 1-1 4h-2v2h-6l-3-4z",
    fill: "#E8E6E5"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,241)",
    d: "m0 0 3 3 1 7-6-2-5-2 3-3z",
    fill: "#27201D"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,234)",
    d: "m0 0 1 4-2 6-3 8h-2l2-13 2-4z",
    fill: "#523E33"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,225)",
    d: "m0 0 3 1 1 6-6 2-2-1v-2l-2-1 4-4z",
    fill: "#F3C59B"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,187)",
    d: "m0 0 2 3v14h-2v2l-6 1 3-5 2-2z",
    fill: "#2A2A2A"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,172)",
    d: "m0 0 3 1-2 1-1 4-10 5-3-1 4-3h2v-2h2v-2l-2-1 4-1h2z",
    fill: "#855F42"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,700)",
    d: "m0 0 5 1 13 7-1 2-7-1-4-4-6-3z",
    fill: "#423D3A"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(650,646)",
    d: "m0 0h5l-3 5-3 1h-7l-1-4z",
    fill: "#2C343C"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,540)",
    d: "m0 0 9 1v10h-1v-5h-5l-1 6h-1z",
    fill: "#444C54"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(793,459)",
    d: "m0 0h1v10l6-1v4l-6 3-2-2z",
    fill: "#4D5861"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(505,363)",
    d: "m0 0 3 1-1 4v11l-3 1-2-9 2-7z",
    fill: "#6E7B8B"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,347)",
    d: "m0 0 1 2h3v2h3v2l5 2 5 5 2 4-4-2v-2l-5-2-4-2-1-3-5-3z",
    fill: "#B9C4D6"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,73)",
    d: "m0 0 4 2-3 6-1-2-5-1-8-1v-2z",
    fill: "#765337"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,24)",
    d: "m0 0 6 1-3 10-3 4h-2v-7h3l-1-2z",
    fill: "#E6E2DF"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,626)",
    d: "m0 0 4 2-1 1 2 1 1 9-5 1z",
    fill: "#E8E6E5"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,604)",
    d: "m0 0h17l-3 2 1 2h-16z",
    fill: "#E2D2BA"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,563)",
    d: "m0 0 11 1v4h-13z",
    fill: "#1D2123"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,218)",
    d: "m0 0 8 6 8 7 2 4h-3l-11-11-2-1v-2l-3-1z",
    fill: "#E6E5E4"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,179)",
    d: "m0 0v3l-16 17-4 3 2-4 7-8z",
    fill: "#E6E2E0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(257,821)",
    d: "m0 0 7 1 3 5 5 5 3 4h-3l-7-8-4-4-5 1-3 3-2-1z",
    fill: "#D9D8D6"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,796)",
    d: "m0 0h4l1 2 1-2 4 2-2 2h-5v2h-2l-1 3h-3l1-8z",
    fill: "#1A1F22"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(235,535)",
    d: "m0 0h6l-2 4-2 2-1 5h-3v-10z",
    fill: "#272F37"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,385)",
    d: "m0 0 2 3 2 8 4 3 2 5-4-2-5-5-3-9z",
    fill: "#BDCADF"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432,219)",
    d: "m0 0 3 1v2l-7 3-10 1 1-2 10-4z",
    fill: "#231917"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,648)",
    d: "m0 0 16 8 7 4-2 2-17-9-5-4z",
    fill: "#4F4741"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,645)",
    d: "m0 0h7l3 1h8l-3 2-10 1-3 2h-2z",
    fill: "#E6DED6"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,589)",
    d: "m0 0 2 1 1 2-10 5-4-1h-5l3-2z",
    fill: "#E6DED6"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,391)",
    d: "m0 0 1 2h2l4 8v7l2 1-3 1-6-16z",
    fill: "#4F6681"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,274)",
    d: "m0 0h5l-3 6-2 6-2 1-1-2v-6z",
    fill: "#E7E2DE"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,690)",
    d: "m0 0 2 2 7 2-1 2 3 2-5 1-5-2-3-3z",
    fill: "#D2B080"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,574)",
    d: "m0 0 9 3 5 3 4 1v2l-10-2-8-3v-3z",
    fill: "#788AA2"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,100)",
    d: "m0 0 1 3 2 1-10 9-3 2 1-4 8-10z",
    fill: "#D7B27B"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(182,599)",
    d: "m0 0 2 2-6 2-9 1h-9l2-2z",
    fill: "#F9F7F2"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,585)",
    d: "m0 0 9 1-1 2-8 1h-11l1-2z",
    fill: "#3B3D3F"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,573)",
    d: "m0 0 4 2 1 3-14 4-1 1h-5l2-2 11-4h2z",
    fill: "#7188A7"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,476)",
    d: "m0 0h10l-4 2h-2l1 4-1 2v10l4 1-5 1v5h-1v-23z",
    fill: "#D9DCDE"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,469)",
    d: "m0 0h16v1l-6 1-1 12h-1l-1-8-5-2v-2z",
    fill: "#8A9BAD"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(37,331)",
    d: "m0 0h2l2 11 1 5-1 2h-2l-2-5z",
    fill: "#252E36"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,234)",
    d: "m0 0h18l-1 2-3 1h-12l-3-2z",
    fill: "#653724"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,33)",
    d: "m0 0 1 2 5-1 2 2-1 5-9-2z",
    fill: "#E7E4E1"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(440,11)",
    d: "m0 0 6 1v3l4 1v2l-4-1-1 2h-3l-1-3h-3z",
    fill: "#E6E3E0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,913)",
    d: "m0 0 1 3-5 5h-2l-1 3-3 2-1 3-6 4-2-1 4-4h2l2-4 9-8z",
    fill: "#E3DFDB"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(196,484)",
    d: "m0 0 2 3 3 8v6h-2l-1 4-2-15z",
    fill: "#DDCEB3"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,481)",
    d: "m0 0 2 1-4 8-2 3h3l-1 3-3 2-1-10h2l2-5z",
    fill: "#A6794E"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,371)",
    d: "m0 0 7 1 7 3-1 3-11-4-6 2 2-4z",
    fill: "#7C93BE"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,272)",
    d: "m0 0 12 1 1 2h-2v2l2 2-1 1h-6l1-6-7 1z",
    fill: "#E8E6E5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,662)",
    d: "m0 0 4 4-9 3-10 1 3-2 5-3 6-1z",
    fill: "#A2ACBC"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,662)",
    d: "m0 0 7 2 5 5 3 2h-2l-1 2-5-2-1-4-6-3z",
    fill: "#EDCB9F"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,622)",
    d: "m0 0 14 2-1 2-3 1h-8l-2-1z",
    fill: "#F9F3DF"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,569)",
    d: "m0 0 14 1v1l-7 1h-28v-1l18-1z",
    fill: "#BFBCB6"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,536)",
    d: "m0 0 2 3 2 5 2 1v2l9 1v1h-7l-4-2-5-1z",
    fill: "#CACFD4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,303)",
    d: "m0 0 1 4-3 9-1 7h-2v-9l4-10z",
    fill: "#815337"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,300)",
    d: "m0 0 5 1v4l4 2-1 3-5-3v-2h-5z",
    fill: "#E6E1DC"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,269)",
    d: "m0 0 6 1 3 3v3h-7z",
    fill: "#E0E3E6"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,271)",
    d: "m0 0m-1 1m-1 1 1 3 2-1-1 8-3-2-2 2v-2l-3-1 1-4z",
    fill: "#E7E2DE"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,227)",
    d: "m0 0h5l-6 3 4 2h-15v-3z",
    fill: "#E0BA88"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361)",
    d: "m0 0 3 1-2 4-3 8h4l2-2v5h-7l-2-5h2v-5l-1-2h4z",
    fill: "#E3DFDC"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(277,810)",
    d: "m0 0 8 2 7 5v2l4 1-3 1-15-9z",
    fill: "#443E3A"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(328,714)",
    d: "m0 0 10 1 1 3 2 1-1 1h-6l-6-4z",
    fill: "#EBBF94"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,688)",
    d: "m0 0 9 1 2 2-2 2-2-2v3l-3 1-5-3 2-1z",
    fill: "#BB9974"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,546)",
    d: "m0 0h5l1 2 6 2v3h4l1-3 4 2-3 1 1 2-10-2-9-6z",
    fill: "#726154"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(448,488)",
    d: "m0 0 2 1-3 5-7 5h-4v-2l8-6z",
    fill: "#946541"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,228)",
    d: "m0 0h7v1h-6v3h8v1h-17l1-3z",
    fill: "#AC825A"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,129)",
    d: "m0 0 3 3 1 3v12l-2-4-3-9z",
    fill: "#2B2423"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,105)",
    d: "m0 0 2 1-2 5-5 6h-5l1-3 5-4z",
    fill: "#221C1C"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,734)",
    d: "m0 0 5 1v2h4l3 6-4-2-5-1-1-2-1 7h-1z",
    fill: "#DFD9CE"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(420,634)",
    d: "m0 0 6 2 8 4 8 2v3l-6-1-16-9z",
    fill: "#E7BE8F"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,553)",
    d: "m0 0h1v5l-4 4-8 6 2-4 7-9z",
    fill: "#D5D6D7"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,477)",
    d: "m0 0 1 2 3 1 1 4-1 2h-2l-1 4v3l-2-2v-9z",
    fill: "#E8E6E5"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,477)",
    d: "m0 0 7 3v3l-3 5h-2z",
    fill: "#E4C798"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,475)",
    d: "m0 0 5 1v1l-15 3-1 2-4-5 10-1z",
    fill: "#B28659"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,420)",
    d: "m0 0 4 2 2 11-1 4-4-5 1-2z",
    fill: "#9AA5B9"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,237)",
    d: "m0 0 2 1-1 2 3 1 2 4h-3v-2h-2v-2l-7 5h-2l2-5z",
    fill: "#E8E6E5"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,222)",
    d: "m0 0 2 1zm-3 1h3v2l-5 3h-2l-2 13h-1l-1-7h-3l6-7z",
    fill: "#CCA87C"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,189)",
    d: "m0 0 1 3-2 9-6 4 1-4z",
    fill: "#6A432E"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,55)",
    d: "m0 0h8l7 3v3l4 2-2 1h-8l4-2v-2l-9-3z",
    fill: "#5D412E"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,651)",
    d: "m0 0 7 1 8 3-3 3-9-3v-2l-4-1z",
    fill: "#F3C59B"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,557)",
    d: "m0 0 4 1 3 2v7l-5 1v-5l2-2z",
    fill: "#EFEEEB"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,554)",
    d: "m0 0h5l3 2 4 2-10 2h-5l1-5z",
    fill: "#D9D4CD"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,468)",
    d: "m0 0 3 1 2 16-3-1-2-13z",
    fill: "#464D55"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,452)",
    d: "m0 0 6 2 2 2 4 1v2l4 1v2l-4-1-10-5z",
    fill: "#635042"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,288)",
    d: "m0 0 9 3 1-3 5 5-1 1h-8l-6-4z",
    fill: "#E9E2C7"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,231)",
    d: "m0 0 2 1-5 6h-2v4l-5 3h-2l1-3 3-3-1-3 7-3z",
    fill: "#DDDFE1"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,175)",
    d: "m0 0 2 4 1 11h-1l-1 10h-1l-1-18z",
    fill: "#5E554F"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,130)",
    d: "m0 0 1 2-3 5-3 1-1 4v-2l-4 1 2-6 4-2h2z",
    fill: "#3B2A24"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,60)",
    d: "m0 0h3l-1 3-13 6 1-5z",
    fill: "#322925"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(375,655)",
    d: "m0 0 6 2 8 5-1 3-3-1 1-2-7-1z",
    fill: "#DDDFE1"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,542)",
    d: "m0 0h4l-1 4-1 2-5 1-5-1 5-4z",
    fill: "#46413E"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,469)",
    d: "m0 0 3 1-3 3h7v2h-12v-2l-2-2z",
    fill: "#DDD4C6"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,301)",
    d: "m0 0 5 3v3l-8 1-1-4 4-1z",
    fill: "#E8E6E5"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,279)",
    d: "m0 0h2v2l4 1 4 5v2l-5-2-2-2-6-1 1-2h2z",
    fill: "#E7E2DD"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,270)",
    d: "m0 0v3l-5 6-7 10-1-2 6-11z",
    fill: "#835436"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(380,840)",
    d: "m0 0h1l1 12h5l-2 5-5 1z",
    fill: "#E2DEDA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,841)",
    d: "m0 0 4 1 5 4v2l-5-2v-2l-4 1-7 6-2-1 7-7h2z",
    fill: "#DFDEDD"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,635)",
    d: "m0 0 3 1 1 6-1 7h-2v3h-3l1-5 2-4z",
    fill: "#B8936D"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,605)",
    d: "m0 0h2v2l-6 3-5 2-2-2 1-1-3-2z",
    fill: "#C6A781"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,585)",
    d: "m0 0 2 2 25 1v1l-19 1-4 1-4-3z",
    fill: "#454749"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,577)",
    d: "m0 0 4 1-2 1v20h-1l-2-14v-7z",
    fill: "#AF9275"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,572)",
    d: "m0 0 5 1 1 2-3 3-7 1-1-2h4l-2-1v-2h3z",
    fill: "#9DA5AE"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,553)",
    d: "m0 0 3 1 1 2v8h-3l-3-7 2-1z",
    fill: "#2C3338"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,551)",
    d: "m0 0 3 4v11l-2 4-2-13v-5z",
    fill: "#44413F"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,530)",
    d: "m0 0 4 2 5 10-4-2-3-1z",
    fill: "#8B9AAB"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,457)",
    d: "m0 0h3l1 14 1 9-2-1-1-4-1-16-5 1 1-2z",
    fill: "#68727E"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,445)",
    d: "m0 0 1 3h2l3 12v6l-3-2-3-15z",
    fill: "#4C5D6F"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,425)",
    d: "m0 0 3 4v14h-2l-1-6z",
    fill: "#232021"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,363)",
    d: "m0 0h3l-1 4-6 4-4 1 2-5z",
    fill: "#F1EFEE"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(229,332)",
    d: "m0 0 5 2 2 1-1 5 3 1-12-1v-1h7v-2l-3-1z",
    fill: "#E4E4E4"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(600,232)",
    d: "m0 0h2v2h-2l-1 4-7 3-1-2 1-1v-3l6-2z",
    fill: "#594433"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,131)",
    d: "m0 0 2 3 2 10v7l-2-1-2-7z",
    fill: "#553122"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,810)",
    d: "m0 0 1 3-5 3h-6v2l-5 1v-2l2-2v-2h10z",
    fill: "#E4E0DB"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,802)",
    d: "m0 0 4 2v2h-2l-1 2-1-1-2 5-5-1 1-2h2l2-4z",
    fill: "#1F2124"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,576)",
    d: "m0 0h2l-1 7-2 8-3-1 1-7z",
    fill: "#202224"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,541)",
    d: "m0 0h2l-2 4-4 7 3 1h-4v-3l-3-1 2-1 2-4z",
    fill: "#9C6F48"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,472)",
    d: "m0 0h2l1 3v7h-1l-1-6-9 1-8 1 1-2 12-3z",
    fill: "#B28D68"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(438,42)",
    d: "m0 0 6 1-2 9 4 1-6 1-4-6 4 1-1-4z",
    fill: "#DFDAD5"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,642)",
    d: "m0 0m-6 1h6l-1 3h-5v2h-3v2l-3-1-1-2 3-2z",
    fill: "#EFC59A"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,603)",
    d: "m0 0 8 1v3h-11l-4-2 2-1z",
    fill: "#353D45"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,594)",
    d: "m0 0 6 1 2 3-10 2 1-5z",
    fill: "#EEC197"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,582)",
    d: "m0 0 9 3-1 4-6-2-6-3z",
    fill: "#CDB190"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,573)",
    d: "m0 0 9 1v2l3 2h-12z",
    fill: "#E0E3E5"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,559)",
    d: "m0 0 9 3 5 4-6-1-4-1-2 2h-7v-1l6-1z",
    fill: "#71859B"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,472)",
    d: "m0 0 3 2 1 9-1 1h-6l2-2z",
    fill: "#705E4E"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,164)",
    d: "m0 0h1l1 6v14l-2 1v-6l-1-4z",
    fill: "#5A4231"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,81)",
    d: "m0 0h3l-1 4-4 7-4 1 2-5z",
    fill: "#634732"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,23)",
    d: "m0 0h3l1 8 2 8-3-2v-2h-2v-6l-1-1z",
    fill: "#E7E2DE"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,805)",
    d: "m0 0h2v2l-8 7-1 2h-2l-1 3v-2l-3-1v-2l6-2 4-5z",
    fill: "#E4E5E6"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,573)",
    d: "m0 0 4 2 8 1 1 3h-8l-7-3 2-1z",
    fill: "#7E90A4"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,570)",
    d: "m0 0 6 1 6 2 2 4h-5l-9-5z",
    fill: "#6C83A7"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,560)",
    d: "m0 0h7l-4 2-11 3h-5v-2z",
    fill: "#363B3F"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,547)",
    d: "m0 0 6 1 2 2-2 2-6 1v-2h-2v-3z",
    fill: "#262E36"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(129,533)",
    d: "m0 0 9 3-5 4-4 2z",
    fill: "#4F565E"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(4,528)",
    d: "m0 0 8 1v4l-9-1z",
    fill: "#FCFBFA"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(360,262)",
    d: "m0 0 2 1 1 2-6 4h-2v6l-2-3v-5z",
    fill: "#694432"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,238)",
    d: "m0 0 2 3 2 2 2 3-1 2h-2v-2h-4l-2-7z",
    fill: "#E4DDD6"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,213)",
    d: "m0 0 2 4-4 2v3l-3-1-3-2v-2l7-3z",
    fill: "#9B6A40"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,187)",
    d: "m0 0 2 1-11 8-8 4v-3l7-4z",
    fill: "#2E231F"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,65)",
    d: "m0 0h4v2l-6 5v2l-4-2v-4l4 1v-2h2z",
    fill: "#DFDCDA"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,44)",
    d: "m0 0h2v2h-2l1 8h-3v-5h-2v-2l-2-1z",
    fill: "#E7E2DE"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,788)",
    d: "m0 0h2v3l3-1v2h-2v2h-4l-2 2h-3v-2l-2-1h6v-3h2z",
    fill: "#1B1D20"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,772)",
    d: "m0 0 2 2v5h-2v3l-5 2v-3l3-4z",
    fill: "#DCE0E3"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(276,682)",
    d: "m0 0 6 2 6 3-3 3-5-2-4-3z",
    fill: "#CDAC80"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(160,606)",
    d: "m0 0h5l-5 4-5 3h-3l2-4z",
    fill: "#F5E9C0"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,583)",
    d: "m0 0 8 3 3 3-8-1-7-3z",
    fill: "#282B2E"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(199,506)",
    d: "m0 0 3 6h4l2 7-6-2v-3h-2z",
    fill: "#D7B281"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,330)",
    d: "m0 0 8 4 5 4-1 3-5-4-7-4-2-2z",
    fill: "#4C5B70"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,293)",
    d: "m0 0 4 1 1 8-2 1-3-3z",
    fill: "#E7E5E4"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,265)",
    d: "m0 0h11v4l-9 4-4-1 3-2 7-2 1-2h-9z",
    fill: "#DBB783"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,210)",
    d: "m0 0h7l-1 3 3 1-3 4-6-6z",
    fill: "#DCB784"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(324,173)",
    d: "m0 0h1l1 12 1 8-2 5h-1z",
    fill: "#564E47"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528)",
    d: "m0 0 4 1 3 7 2 3v3h-2l-4-7-4-3z",
    fill: "#E2DFDD"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,780)",
    d: "m0 0 4 1-1 5-5 3-3-1 2-1z",
    fill: "#77818C"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,575)",
    d: "m0 0 3 3v8l-2 10h-1z",
    fill: "#3A444C"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,534)",
    d: "m0 0 3 1 1 4 6 3 5 6-5-2-8-6z",
    fill: "#A28A76"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,529)",
    d: "m0 0h6l-2 3h-5l2 5-4-1-2-6z",
    fill: "#68717E"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,476)",
    d: "m0 0 2 4 3 16-3-1-1-2v-8z",
    fill: "#4A5B6C"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,328)",
    d: "m0 0 6 2 12 2 4 2-10-1-13-1z",
    fill: "#D9DFE4"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,316)",
    d: "m0 0h2l-2 5h-2l-2 4-2 1 1-7z",
    fill: "#272E34"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,284)",
    d: "m0 0 14 1v2h-15l-1-2z",
    fill: "#E7E2DE"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(287,164)",
    d: "m0 0 2 1-8 9-5 5h-2l2-4 5-5z",
    fill: "#E2E3E4"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,79)",
    d: "m0 0 4 1 13 13h-3l-8-8-6-4z",
    fill: "#8A5B38"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,73)",
    d: "m0 0 2 1-3 5-6 4h-2v-4z",
    fill: "#39302C"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(528,59)",
    d: "m0 0 4 1v2l-4 2h-14v-4h2v2l9 1 1-2z",
    fill: "#DCB683"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,791)",
    d: "m0 0h6v2l-4 1v2h-2l-1 3-1-3h-2l-1 2v-4h3v-2z",
    fill: "#181112"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(369,609)",
    d: "m0 0 3 1v12l-2 4-1-2z",
    fill: "#E0DDD6"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,603)",
    d: "m0 0h5l1 2-1 3-9-2-2-2z",
    fill: "#F2C49A"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,566)",
    d: "m0 0 8 2v3h-9z",
    fill: "#CCB89D"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,562)",
    d: "m0 0h18l-3 2v2h-6v-2h-10z",
    fill: "#4B555D"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,557)",
    d: "m0 0 1 2h2l2 2 1 2 4 1-1 2-8-1-1-5z",
    fill: "#303B46"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,545)",
    d: "m0 0 2 2 1 18-3-3-1-7h1z",
    fill: "#454A4F"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,550)",
    d: "m0 0h1v15l-2-1-1-13z",
    fill: "#CBD1D3"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,531)",
    d: "m0 0 4 2-14 3-3-1-1-2z",
    fill: "#97806A"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,531)",
    d: "m0 0 3 1-5 10-2-2-1-5z",
    fill: "#4B5358"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(201,514)",
    d: "m0 0 2 3 5 2v7l-3 1-3-8z",
    fill: "#F3C59B"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,282)",
    d: "m0 0h3l-2 5-6 9-3-1 4-5z",
    fill: "#80634E"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(437,163)",
    d: "m0 0 1 2-4 9-1 6h-1v-9l3-6z",
    fill: "#8F5F3D"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,102)",
    d: "m0 0h4l3 5-1 4-3-1-3-5z",
    fill: "#272324"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,93)",
    d: "m0 0 4 1-9 6-7 1 3-3z",
    fill: "#543627"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(432,56)",
    d: "m0 0h6l-1 2-12 4-1-3z",
    fill: "#43352F"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,800)",
    d: "m0 0h3l1 4v8h-2l-2-4z",
    fill: "#1A1B1E"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,601)",
    d: "m0 0 4 1 16 1v1l-27 1v-1l7-1z",
    fill: "#DBB783"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,543)",
    d: "m0 0 3 1-15 8-4-1 5-3 7-3z",
    fill: "#5C759F"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,525)",
    d: "m0 0 2 3 1 8-2 2-3-7z",
    fill: "#444342"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,520)",
    d: "m0 0h7l1 3-4 3-4-1z",
    fill: "#E6E0D9"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,429)",
    d: "m0 0 2 4 2 10v5h-3l-1-7z",
    fill: "#50657B"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,436)",
    d: "m0 0h4v2l-10 3-2 1-4-1v-2l7-1z",
    fill: "#C9CED0"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,421)",
    d: "m0 0 2 3 2 4 1 13-2-2-2-9z",
    fill: "#4C5863"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,194)",
    d: "m0 0v3l-2 3 6 1 1 2-11-1-1-3z",
    fill: "#E5E4E4"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,192)",
    d: "m0 0h2l-2 5-9 6 2-5z",
    fill: "#231E1E"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,141)",
    d: "m0 0 2 4-3 12h-3l1-5z",
    fill: "#684530"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(21,748)",
    d: "m0 0 11 1 1 3-7 1z",
    fill: "#DEDDDC"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,633)",
    d: "m0 0 7 1 7 4-2 2-12-5z",
    fill: "#7F7D7E"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,620)",
    d: "m0 0 1 3-8 9-3 1 2-4 4-5z",
    fill: "#3D4751"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,619)",
    d: "m0 0 3 1-14 6-8-2v-1l12-1z",
    fill: "#E1BA89"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(155,586)",
    d: "m0 0h8v1l-6 1 1 2h-9v-3z",
    fill: "#494543"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(84,568)",
    d: "m0 0 6 1 1 3-4 3-4-4z",
    fill: "#303A45"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,563)",
    d: "m0 0h5l1 5h-8l1-4z",
    fill: "#25282B"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,558)",
    d: "m0 0h8l6 1v1l-9 1-13-1v-1z",
    fill: "#A99F96"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,345)",
    d: "m0 0h1l2 9-1 10h-1l-2-18z",
    fill: "#2D2B2C"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,344)",
    d: "m0 0 5 1-1 3h7l2 3-13-1 1-3h2v-2z",
    fill: "#E8E6E5"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,298)",
    d: "m0 0 2 3v2h2v10l-3-3z",
    fill: "#6D432D"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,280)",
    d: "m0 0h7l1 5-1-3h-3l-2 5-6 1 4-4z",
    fill: "#4A5359"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,206)",
    d: "m0 0 4 1-4 5h-2l-5 1 1-3z",
    fill: "#6B5B4D"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,139)",
    d: "m0 0 2 3 3 11-1 4-1-7h-3z",
    fill: "#4A4948"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,102)",
    d: "m0 0 2 1 2 9v5l-3-1z",
    fill: "#855C3C"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,6)",
    d: "m0 0h2v7l1 5h-4v-9z",
    fill: "#DCDAD7"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,779)",
    d: "m0 0 1 4h-2l-1 4-6 2 1-6 7-1z",
    fill: "#E7E6E5"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,664)",
    d: "m0 0 5 1 4 3 5 2-3 3-8-5z",
    fill: "#B19273"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,654)",
    d: "m0 0 1 3h8l3 3-2 1-8-2-2 4z",
    fill: "#DDDDDC"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,628)",
    d: "m0 0 5 1 6 3-4 2-5-2-1 2z",
    fill: "#A4978C"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(188,609)",
    d: "m0 0h3l-2 4-5 3-5-1 1-2z",
    fill: "#F3C59B"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,572)",
    d: "m0 0h2l1 5v8h-2l-1-3z",
    fill: "#6E8196"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,572)",
    d: "m0 0h2l-1 3 5 2v1l-12-1v-2z",
    fill: "#CBA97E"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,556)",
    d: "m0 0h8l1 3h-2v2l-5-1z",
    fill: "#1B1D1F"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,536)",
    d: "m0 0 3 1-2 2 3 3-5 2v-2l-4-2z",
    fill: "#E3BD8E"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,504)",
    d: "m0 0 4 1 3 8 2-1-1 4h-2l-6-9z",
    fill: "#7C91A8"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,496)",
    d: "m0 0 12 6-2 3-10-6z",
    fill: "#7C5239"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(463,491)",
    d: "m0 0 4 1 6 5v3l-4 1v-4l-3-2v-2l-3-1z",
    fill: "#E9DCBE"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,357)",
    d: "m0 0 6 5v2l3 1v3l-4-2-1-3-4-2-1-2z",
    fill: "#765F4E"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(403,357)",
    d: "m0 0h3v2l17-1-3 2-11 1-5 1z",
    fill: "#D7B381"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,348)",
    d: "m0 0m-1 1 1 2-5 5-4 1 1-5z",
    fill: "#B5C1D5"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(276,302)",
    d: "m0 0 1 2 5 1-3 2-7 2 1-4z",
    fill: "#E8E6E5"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,270)",
    d: "m0 0 2 1-1 6-5 1v-3l1-3z",
    fill: "#28313A"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,262)",
    d: "m0 0 10 1 1 2-5 2-5-1 1-3z",
    fill: "#151214"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,248)",
    d: "m0 0 6 3v2h2l1 2 3 2-2 2-6-4-3-5z",
    fill: "#E6E5E4"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,221)",
    d: "m0 0 2 2-1 1 6 3-2 2-7-2-1-4z",
    fill: "#594433"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,214)",
    d: "m0 0 3 3v3l3 1-1 2h-3l-5-5 1-2z",
    fill: "#413129"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,201)",
    d: "m0 0 3 2 1 4-8 2 2-6z",
    fill: "#DEB986"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,80)",
    d: "m0 0 2 1-2 4-6 5h-2l2-4 4-5z",
    fill: "#362721"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,72)",
    d: "m0 0 6 2 5 5h-3l-10-5z",
    fill: "#734A30"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,70)",
    d: "m0 0h7v2l-5 1 1 3-4-1-1-4z",
    fill: "#F3E5B7"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(494)",
    d: "m0 0h2v9l-4-1-1-3z",
    fill: "#E7E3E0"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(500,826)",
    d: "m0 0 3 1-6 5v6l-4-3 2-5z",
    fill: "#323132"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,667)",
    d: "m0 0 3 1-5 3-9 3h-2v-2z",
    fill: "#EAD7AC"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,665)",
    d: "m0 0 9 4v2l-6 1-3-4z",
    fill: "#EEC397"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,579)",
    d: "m0 0 7 1 1 3-7 1-5-1v-1l5-1z",
    fill: "#51565A"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,544)",
    d: "m0 0h3l-1 3-6 4h-4v-2z",
    fill: "#75482F"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,520)",
    d: "m0 0h2l2 7-1 8-2-4z",
    fill: "#DFBA8E"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,333)",
    d: "m0 0h5v9l-3-1z",
    fill: "#D6DEE4"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(356,333)",
    d: "m0 0 3 1-4 6-1 5h-1l-1-9z",
    fill: "#E7E5E4"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,325)",
    d: "m0 0h3l4 7v4l-3-1-4-8z",
    fill: "#714832"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(319,304)",
    d: "m0 0 6 2v1l-7 2-5-1 1-2z",
    fill: "#DFE2E4"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,283)",
    d: "m0 0 2 4v8h-4v-6z",
    fill: "#A5784F"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,259)",
    d: "m0 0 2 4 1 12-2-2-3-12h2z",
    fill: "#B18559"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,252)",
    d: "m0 0h10l1 2-2 1h-10z",
    fill: "#12171A"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,239)",
    d: "m0 0 2 1v3l-11 7 2-4h2l2-4z",
    fill: "#E6E3E1"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,239)",
    d: "m0 0 2 1 1-1 7 1v2h-7l-1 2-6-2z",
    fill: "#633825"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,227)",
    d: "m0 0 7 4 5 6 1 4-3-3-4-5-8-4z",
    fill: "#D5B181"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,22)",
    d: "m0 0h2l1 4 3 2-1 4h-3l1-4-4 2z",
    fill: "#E1DEDB"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,813)",
    d: "m0 0 6 1v2l-8 1-3 2-1-5h4z",
    fill: "#131416"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12,733)",
    d: "m0 0 5 1 4 2-1 2-12-1z",
    fill: "#E1DFDD"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,716)",
    d: "m0 0 3 1 2 5-1 3h-3l-1-2z",
    fill: "#D6CFC6"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,670)",
    d: "m0 0h3l2 5h2v2l-5-1-3-3z",
    fill: "#666C73"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(149,614)",
    d: "m0 0 2 3 8 4 1 2-5-1-6-3v-3l-3-1z",
    fill: "#EAD3A9"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(145,611)",
    d: "m0 0h4l-2 4 2 1v2l-6-2-2-1v-2h4z",
    fill: "#D1AE80"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,598)",
    d: "m0 0 6 1 10 3 2 3-10-3-8-2z",
    fill: "#2B3238"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,586)",
    d: "m0 0 6 5-4 2h-3l-1 2v-3-3h2z",
    fill: "#D4C5B3"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(102,576)",
    d: "m0 0 1 3-4 6-5-1v-3l5-1z",
    fill: "#222628"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,566)",
    d: "m0 0h5l-3 2-7 3h-4l1-3z",
    fill: "#19191C"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,522)",
    d: "m0 0h5l2 2v4l-5 1v-3l1-3z",
    fill: "#E6DED6"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,502)",
    d: "m0 0h2l4 8v3h-2l-5-10z",
    fill: "#7A8FA8"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,481)",
    d: "m0 0 2 3v6l3 4-4 2-3-5h2z",
    fill: "#7086AC"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,254)",
    d: "m0 0h4l2 6-3 3v-2l-5-1 4-3z",
    fill: "#637BA7"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(516,199)",
    d: "m0 0 4 5v7l-3-1-1-7z",
    fill: "#3C2D26"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,167)",
    d: "m0 0 1 2-1 7-3 2-1-4 2-5z",
    fill: "#3B2D26"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,103)",
    d: "m0 0h5l-2 4-3-1-7 8v-3z",
    fill: "#3E3530"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,95)",
    d: "m0 0 5 5 1 3-5-1-2-2z",
    fill: "#1F1A1B"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(482,12)",
    d: "m0 0 6 1 2 1v2h-6l-4 1z",
    fill: "#E7E4E2"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447)",
    d: "m0 0h8v3l-5 1-4 2z",
    fill: "#E0DDDA"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,787)",
    d: "m0 0h5l4 2 7 1-2 3-10-3-4-2z",
    fill: "#E5E3E3"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,710)",
    d: "m0 0 6 2 8 4-1 2-4-1-3-1-3-3-3-1z",
    fill: "#413D38"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(26,709)",
    d: "m0 0 5 1v2h-2l1 3-4 2-2-7z",
    fill: "#DFE1E3"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,696)",
    d: "m0 0h8l-3 2-9 3-4-1z",
    fill: "#F3C59B"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(547,629)",
    d: "m0 0h5l-4 3-9 3h-3v-2z",
    fill: "#E2C383"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,587)",
    d: "m0 0 8 1-4 3h-7l-3-2z",
    fill: "#727274"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,572)",
    d: "m0 0 7 1v3l-4 1-6-1z",
    fill: "#F3C59B"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,556)",
    d: "m0 0 8 1 1 5h-5l-1-3h-2z",
    fill: "#607081"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,525)",
    d: "m0 0h2v7l-2 4-2-1 1-8z",
    fill: "#A1ABB6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,518)",
    d: "m0 0 5 5-2 7-3-6z",
    fill: "#F3EBD1"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,381)",
    d: "m0 0h10v6l-10-5z",
    fill: "#3A424B"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,358)",
    d: "m0 0 1 2-11 7-2-2 9-6z",
    fill: "#483F39"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,313)",
    d: "m0 0h6l1 5-2 4h-1v-7h-4z",
    fill: "#E8E6E5"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(277,219)",
    d: "m0 0 3 2-8 7h-2l2-4z",
    fill: "#DFE1E3"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,116)",
    d: "m0 0h3l-2 5-6 3-2-1 3-3 1-3z",
    fill: "#252020"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,797)",
    d: "m0 0h1l1 8 2-5 2 1-2 6-3 1-1 2z",
    fill: "#D3CEC8"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(233,793)",
    d: "m0 0 5 2 1 4-7 5v-3l5-2v-3l-4-1z",
    fill: "#CED0D1"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,779)",
    d: "m0 0 5 1 6 3v2l-5-1-5-2h-3v-2z",
    fill: "#D8D4CE"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,741)",
    d: "m0 0h6l5 2-1 4h-2v-2l-4-1z",
    fill: "#3F464D"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(92,725)",
    d: "m0 0h3l1 2 7 1v4h-2v-3l-6 1v-2h-3z",
    fill: "#D8CFC3"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,698)",
    d: "m0 0h9l4 1v2h-7l-6-2z",
    fill: "#C8A77F"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,679)",
    d: "m0 0 9 1 2 2-1 4-10-6z",
    fill: "#F3E8C4"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(279,676)",
    d: "m0 0 6 1 5 2-3 2-9-3z",
    fill: "#AE937B"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,652)",
    d: "m0 0 1 3-12 3-3-1z",
    fill: "#CCA36F"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,570)",
    d: "m0 0 13 5-3 2-6-2-4-3z",
    fill: "#D5B68E"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,560)",
    d: "m0 0 1 4 8 1v3l-7-1-3-2z",
    fill: "#2A3239"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,546)",
    d: "m0 0 2 1v4l-4 2-2-1 1-4z",
    fill: "#18191C"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(752,524)",
    d: "m0 0 6 6-4 2-3 1z",
    fill: "#FCFBFA"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,487)",
    d: "m0 0h2l-2 4-4 1h-5l3-3z",
    fill: "#E6E5E4"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,459)",
    d: "m0 0h5v2l2 1-3 3-3-1z",
    fill: "#D9D6D3"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,438)",
    d: "m0 0 5 1v4l-5 2z",
    fill: "#E6DED6"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,324)",
    d: "m0 0h2l1 11h-3l-1-3z",
    fill: "#2D3339"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,318)",
    d: "m0 0 4 1 1 3-6 3v-6z",
    fill: "#FCFBFA"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,308)",
    d: "m0 0 5 1 1 2-9 2 1-4z",
    fill: "#F2F3F3"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,298)",
    d: "m0 0 1 3 5 2 3 4-5-1-4-2-1-5z",
    fill: "#E8E6E5"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,265)",
    d: "m0 0h1v9l-2 8h-2l1-7z",
    fill: "#604232"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,264)",
    d: "m0 0 5 1 5 5v2l-5-2-2-1v-2z",
    fill: "#242526"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(465,249)",
    d: "m0 0 5 1 3 2-1 3-2-1 1 2-6-2v-4z",
    fill: "#E8D4A9"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(442,242)",
    d: "m0 0 7 1-4 2-3 1-8-2v-1z",
    fill: "#D3AD7E"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,224)",
    d: "m0 0 3 4-1 5h-1v-6l-9 1 3-3 5 1z",
    fill: "#543426"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,207)",
    d: "m0 0v3l-8 4-3-1 7-5z",
    fill: "#1F1A1A"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(491,173)",
    d: "m0 0 3 1-6 7-1 2h-2l1-5z",
    fill: "#623C29"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,34)",
    d: "m0 0 7 1-1 2-4 2h-4l1-4z",
    fill: "#E7E5E3"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(272,805)",
    d: "m0 0 8 4v3l-10-4 2-1z",
    fill: "#5D4C40"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,687)",
    d: "m0 0h6v4l-6 1z",
    fill: "#E6DFD8"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,682)",
    d: "m0 0h2l-1 3-7 3h-6l2-2 5-2h5z",
    fill: "#E7E3E0"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(309,676)",
    d: "m0 0 7 4v1l-10-1-1-2z",
    fill: "#676F79"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,642)",
    d: "m0 0 3 1-9 4-6 1v-2z",
    fill: "#9F8F7E"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,632)",
    d: "m0 0 5 1 9 6h-3l-7-3-1-2-3-1z",
    fill: "#3E3A36"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,580)",
    d: "m0 0h2l3 3v2h-8v-3z",
    fill: "#79797D"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,569)",
    d: "m0 0h1l1 5v8l-3 1z",
    fill: "#A1ABB4"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,566)",
    d: "m0 0h2v10l-1 5-2-1v-7l1-1z",
    fill: "#444240"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,558)",
    d: "m0 0h1l1 7-5 1h-4v-3l4-1v2h3z",
    fill: "#B89F85"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(443,551)",
    d: "m0 0 6 2 2 1v2l5 2-3 1-9-5z",
    fill: "#72869E"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(542,534)",
    d: "m0 0h6l-2 2-8 2h-5l2-2z",
    fill: "#76675A"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,511)",
    d: "m0 0h6v2l-2 1h-11l3-2z",
    fill: "#967C63"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(431,497)",
    d: "m0 0 4 1 1 4-1 2h-2v5h-1z",
    fill: "#F0E6C3"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,465)",
    d: "m0 0m-3 1 4 1-3 2-10 1 1-2z",
    fill: "#695746"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,437)",
    d: "m0 0 4 1v6l-3 4z",
    fill: "#EEE5C4"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,408)",
    d: "m0 0h2l1 5h2l4 8v2h-2l-7-14z",
    fill: "#CAD2D7"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,369)",
    d: "m0 0 3 1 1 2 3 2-1 4-3-1-3-5z",
    fill: "#4D5A66"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,257)",
    d: "m0 0h2l-2 5-1 2h-2l-2 4-1-2 2-5z",
    fill: "#6B432D"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,248)",
    d: "m0 0v3l-7 7-3-1 7-7z",
    fill: "#E7E3E0"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,217)",
    d: "m0 0v3l-4 5h-4l2-4 2-2z",
    fill: "#594232"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,167)",
    d: "m0 0h4l1 6-4-2v2h-2z",
    fill: "#1B1515"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,26)",
    d: "m0 0h4l-1 8-3 1z",
    fill: "#E7E3E1"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,22)",
    d: "m0 0h2l1 10-5-2v-3h3z",
    fill: "#E1DFDC"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,11)",
    d: "m0 0h3l1 3 3 3-3 1-4-2-1-3z",
    fill: "#D3D7D9"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480)",
    d: "m0 0h2l2 5v6l-3-1z",
    fill: "#E4DFDA"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,1)",
    d: "m0 0 7 1v4l-4-1-2 2-1-1z",
    fill: "#E2DED9"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,830)",
    d: "m0 0 2 1-8 8-1 3-2-2v-3l5-3z",
    fill: "#DFDAD5"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,791)",
    d: "m0 0 1 2-5 5 2 5-4-2v-4z",
    fill: "#E0DDD8"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,649)",
    d: "m0 0 9 3 1 2h-6l-6-3z",
    fill: "#C7A780"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(650,646)",
    d: "m0 0h5l-3 5-5-1 1-3z",
    fill: "#303B46"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,581)",
    d: "m0 0 5 1 5 2v2l4 2-5-1-7-3v-2z",
    fill: "#C19F78"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,565)",
    d: "m0 0h2l-2 5-8 1v-3h7z",
    fill: "#E8E5E0"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,561)",
    d: "m0 0 6 1v5l-6 2 1-2h2v-4l-3-1z",
    fill: "#E6E3E1"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(222,552)",
    d: "m0 0h9l1 7-1-2-4-2v-2h-5z",
    fill: "#4B5D70"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(17,538)",
    d: "m0 0 3 2-7 3h-4l2-4z",
    fill: "#F4EAC5"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,538)",
    d: "m0 0 3 1v7l-3-1v-3h-2z",
    fill: "#1A1B1D"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,521)",
    d: "m0 0h3l1 5h-5l-1 2v-5z",
    fill: "#E7E5E3"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,509)",
    d: "m0 0h5l-2 1v2l-9 2-1-3z",
    fill: "#635F5E"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(770,508)",
    d: "m0 0 4 1 1 7-3 1v-4l-2-2z",
    fill: "#E8E6E5"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,477)",
    d: "m0 0h2l-1 8h-4l-1 3 1-5 2-1z",
    fill: "#7B90A9"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,473)",
    d: "m0 0h7v2l-5 1h-8l2-2z",
    fill: "#866A52"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,455)",
    d: "m0 0 6 3-5 6h-1z",
    fill: "#DDC7A3"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(474,381)",
    d: "m0 0 2 2v3l-8 1v-3z",
    fill: "#EEE0BB"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,371)",
    d: "m0 0h2l1 4-2 6h-2z",
    fill: "#EDFDFF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,240)",
    d: "m0 0h2l-1 5-2 7h-2l1-7z",
    fill: "#312B29"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(331,229)",
    d: "m0 0 3 1 2 6 3-1-2 5-3-3-3-6z",
    fill: "#79695C"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,210)",
    d: "m0 0 1 3-4 5-3-3 2-4h3z",
    fill: "#584739"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,210)",
    d: "m0 0 3 1-3 2 1 2-4 1v-2l-6 2 3-3z",
    fill: "#463830"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(349,126)",
    d: "m0 0v3l-3 6h-2l1-6zm-6 9m-1 1m-1 1m-2 1 2 1-2 1z",
    fill: "#8B5C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar-3.fb0b2ae79db27dd8c850e326c7bd06b1.svg";
export { ForwardRef as ReactComponent };